/* Affichely — Composition murale (gallery wall).
   Même parti pris que product.js : IIFE, pas de build, pas de dépendance.

   Le principe, repris de l'outil de Desenio : l'acheteur ne dessine pas son mur.
   Il choisit une COMPOSITION déjà dessinée (des emplacements à des formats fixes),
   puis il remplit les emplacements avec des affiches. Rien à faire glisser, aucune
   décision de mise en page à prendre — c'est ce qui rend l'outil utilisable.

   L'aperçu est posé sur une VRAIE photo de salon (mockup-salon2), la même pièce
   vide que celle des mises en situation produit. Un fond photo fixe ne peut pas
   tenir l'échelle cm → pixel stricte de l'ancien mur dessiné : on l'assume. Les
   affiches sont posées sur la zone « mur » de la photo à une taille plausible et
   cohérente, en conservant les proportions RELATIVES entre affiches d'une même
   composition (c'est ce qui compte pour choisir une disposition).

   Le cadre est désormais PROPRE À CHAQUE AFFICHE. L'étape 3 fixe le cadre par
   défaut appliqué aux nouvelles affiches ; chaque affiche posée peut ensuite être
   changée individuellement via la rangée de pastilles sous elle. La géométrie du
   cadre reste celle de la fiche produit (passe-partout = 2,2 % de la largeur de
   l'affiche, « Sans cadre » retire moulure ET passe-partout). */
(function () {
  "use strict";

  var CFG = window.GW_CONFIG || {};

  /* ⛔ LE COMPOSEUR N'ETAIT PAS MESURE. On savait qu'il existait, pas s'il servait :
     aucune balise, donc aucune ligne dans les Statistiques (Adrien, 03/08/2026).
     Meme identifiant de visiteur que « Ma piece » et « Perso », donc un visiteur se
     suit d'un outil a l'autre. Trois evenements seulement : arrivee, ajout d'une
     affiche au mur, panier. */
  function composeurVid() {
    try {
      var v = localStorage.getItem("af:vid");
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem("af:vid", v);
      }
      return v;
    } catch (e) { return ""; }
  }
  var composeurEnvoyes = {};
  window.__composeurLog = function (evenement, detail) {
    if (evenement !== "ajout" && composeurEnvoyes[evenement]) return;
    composeurEnvoyes[evenement] = 1;
    var vid = composeurVid();
    if (!vid) return;
    try {
      fetch("https://runway.dcomdtf.app/composeur-log", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vid: vid, evenement: evenement, detail: detail || "" }),
        keepalive: true, mode: "cors", credentials: "omit"
      }).catch(function () {});
    } catch (e) {}
  };
  /* ⛔ D'OU VIENT-ON ? (Adrien, 06/08/2026 : « la source d'ouverture du composeur, menu ou page
     produit »). Le composeur ne se souvenait de rien : on savait qu'on l'ouvrait, jamais depuis
     quoi, donc impossible de dire si l'entree du menu sert ou si ce sont les fiches produit qui
     l'alimentent. Le referent le dit sans rien demander a personne.
     ⚠️ TROIS VALEURS, PAS DEUX. « direct » existe : lien partage, favori, onglet rouvert. Le
     ranger d'office dans « menu » gonflerait le menu d'un trafic qui ne vient pas de lui. */
  window.__composeurLog("arrivee", (function () {
    try {
      /* ⛔ LA SOURCE EST DECLAREE PAR CE QUI OUVRE, PAS DEVINEE AU REFERENT (Adrien,
         07/08/2026 : « t'es sur qu'ils viennent pas de la modale d'une page produit ? »).
         Il avait raison, et le referent ne pouvait pas le dire :
         - la carte « Composer mon mur » de la fiche ouvre cette page EN MODALE, par fetch et
           injection, donc SANS navigation. `document.referrer` y vaut le referent de la
           FICHE, pas la fiche : un visiteur arrive par Google tombait en « direct » ;
         - et un clic sur l'entree de MENU depuis une fiche produit portait un referent en
           /products/, donc « produit », alors que c'est le menu qui a servi.
         Les deux portes se declarent maintenant, et `afPorteCreation` (global.js) les lit :
         `window.__creationSource` est pose par la modale, qui n'a pas de navigation ou passer
         un jeton ; la session porte le clic quand il y a vraiment navigation, et se vide
         aussitot pour qu'un retour en arriere ne recompte pas la meme porte.
         ⚠️ LA VALEUR PORTE LE HANDLE : « produit:<handle> » depuis le 08/08/2026. Le Studio
         separe les deux a l'affichage, l'ancien « produit » nu reste lisible. */
      var jeton = typeof window.afPorteCreation === "function" ? window.afPorteCreation() : "";
      if (jeton) return jeton;
      /* Sans porte declaree : lien partage, favori, onglet rouvert, moteur de recherche. */
      return "direct";
    } catch (e) { return "direct"; }
  })());

  var COLLECTIONS = CFG.collections || [];
  var ROOM_IMG = CFG.roomImg || "";
  /* Les murs teintes de la fiche produit, repris tels quels (Adrien, 11/08/2026). La rangee
     de pastilles reutilise les classes .pdp-murs/.pdp-mur de base.css : MEME vignette, meme
     cerne, meme anneau de selection que sur la PDP. */
  var FONDS = CFG.murs || [];
  var I18N = CFG.i18n || {};
  /* Le filtre `t` de Shopify rend les traductions DÉJÀ échappées (' -> &#39;). esc()
     ré-échappait ensuite le &, et le bouton affichait « CHANGER L&#39;AFFICHE ». On
     décode une seule fois, ici : le problème n'est pas l'apostrophe, &, < et " cassent
     pareil, et toutes les chaînes passent par t(). */
  var ENT = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'", "&#x27;": "'" };
  function unesc(s) {
    if (s == null) return s;
    s = String(s);
    return s.indexOf("&") < 0 ? s : s.replace(/&(?:amp|lt|gt|quot|#39|#x27);/g, function (m) { return ENT[m]; });
  }
  function t(k, fb) { return (I18N[k] != null && I18N[k] !== "") ? unesc(I18N[k]) : fb; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* Prefixe de langue et devise, lus sur l'objet Shopify de la page : ecrits en dur,
     ils renvoyaient le visiteur sur la version francaise et affichaient des euros a un
     acheteur facture en livres. Le fichier reste autonome — il ne depend pas de l'ordre
     de chargement des scripts. */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function murUrl(path) { return ROOT + String(path).replace(/^\//, ""); }
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  var LOCALE = (window.Shopify && Shopify.locale) || "fr";
  /* ⛔ LE FORMAT DES PRIX VIENT DE LA BOUTIQUE, ET D'UN SEUL ENDROIT : theme.liquid le pose
     dans window.MURMURE_MONEY depuis shop.money_format. Il y avait deux formats concurrents,
     et c'est ce qui faisait sauter la ligne de prix : Liquid servait « dès €10,13 », ce
     formateur le reecrivait en « dès 10,13 € » au chargement, et le prix barre comme le badge
     partaient vers la droite avant de retomber en place (mesure le 06/08/2026).
     Le repli Intl ne sert que si le script d'entete n'a pas tourne. */
  var money = function (c) {
    if (typeof window.MURMURE_MONEY === "function") return window.MURMURE_MONEY(c);
    try { return new Intl.NumberFormat(LOCALE, { style: "currency", currency: CUR }).format(c / 100); }
    catch (e) { return (c / 100).toLocaleString(LOCALE, { minimumFractionDigits: 2 }) + " " + CUR; }
  };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  /* Vignette Shopify : même astuce que global.js, on insère la taille avant l'extension. */
  var thumb = function (url, size) { return url.replace(/(\.[a-z]+)(\?|$)/i, "_" + size + "$1$2"); };

  /* ---- Constantes partagées avec la fiche produit ---- */
  /* Formats du catalogue, en cm. Le module raisonnait encore en ISO A0-A4 : ces
     valeurs n'existent plus comme variantes depuis le passage aux tailles en
     centimetres, et chaque recherche de variante echouait en silence. */
  var A_CM = { "70X100": [70, 100], "50X70": [50, 70], "30X40": [30, 40], "21X30": [21, 30] };
  /* ⛔⛔ LE COMPOSEUR CONNAIT DEUX SUPPORTS (Adrien, 28/08/2026 : « le bouton "composer mon mur"
     si on clique depuis le metallise doit afficher les affiches de type et de prix metallise »).
     Il ouvrait toujours en papier : un client qui venait de choisir une plaque retrouvait des
     prix papier et des cotes papier, sans un mot pour le lui dire.
     ⚠️ LES COTES METAL NE SONT PAS CELLES DU PAPIER : 15x20, 20x30, 30x40, 50x60 contre 21x30,
     30x40, 50x70, 70x100. Une seule se recouvre, et c'est justement celle qui piege. */
  var METAL_CM = { "50x60": [50, 60], "30x40": [30, 40], "20x30": [20, 30], "15x20": [15, 20] };
  var FORMATS_METAL = ["50x60", "30x40", "20x30", "15x20"];  // du plus grand au plus petit
  var ROLE_FMT_METAL = { s: "20x30", m: "30x40", l: "50x60" };

  /* ⛔⛔ ON RECONNAIT UNE COTE METAL A SON JETON NUMERIQUE ET A CE QUI L'ENTOURE, JAMAIS AU MOT.
     Shopify Markets TRADUIT les valeurs d'option : « Métal 30x40 » ne s'ecrit pas ainsi sur les
     douze marches non francais, et un test sur le mot ferait disparaitre toutes les cotes metal
     SANS ERREUR — la liste serait vide et le client verrait « Choisissez une taille » sans une
     seule taille a choisir.
     ⚠️ ET LE JETON SEUL NE SUFFIT PAS : 30x40 existe des DEUX cotes. Ce qui les separe est que la
     cote papier est le jeton NU (« 30X40 »), la cote metal le porte precede d'un mot. On teste
     donc les deux : le jeton appartient au metal, et la valeur n'est pas ce jeton tout seul.
     ⚠️ Le polyptyque (« Polyptyque 2x2 · 50x70 ») porte lui aussi un prefixe, mais son jeton
     n'est pas dans METAL_CM : il sort par la premiere condition, pas par chance. */
  function jetonCote(v) {
    var m = /(\d{2,3})\s*[x×]\s*(\d{2,3})/i.exec(String(v || ""));
    return m ? (m[1] + "x" + m[2]).toLowerCase() : null;
  }
  function estCoteMetal(v) {
    var j = jetonCote(v);
    if (!j || !METAL_CM[j]) return false;
    return String(v).trim().toLowerCase() !== j;
  }
  /* ⛔⛔ LE NUANCIER SE LIT DANS LE DOM, IL NE S'ECRIT PAS ICI. Il vit une fois cote theme
     (`bordure-fonds-json.liquid`), une fois cote presse (`runway/catalogue/fonds-bordure.js`), et
     `tests/bordure-parite.test.js` compare les deux. Une troisieme copie serait une troisieme
     occasion qu'une cliente choisisse a l'ecran une couleur qu'elle ne recevra pas — le reproche
     exact auquel toute cette option repond. Les noms viennent des locales pour la meme raison. */
  /* ⛔⛔ IL S'APPELLE `TEINTES_BORD`, ET SURTOUT PAS `FONDS` (28/08/2026). Ce fichier avait DEJA
     un `var FONDS` — les murs teintes de la fiche, `CFG.murs` — deux cents lignes plus haut. En
     redeclarant le meme nom dans la meme fonction, j'ai remplace la liste des murs par celle des
     bordures : la rangee du bas montrait onze teintes de bordure, `data-mur` valait `undefined`,
     et un clic posait `background-image: url(".../undefined")`. Aucune erreur, aucun banc rouge —
     seulement un fond de mur qui ne changeait plus. C'est Adrien qui l'a vu.
     ⚠️ `var` NE PROTEGE DE RIEN ICI : une seconde declaration dans la meme portee n'est pas une
     erreur en JavaScript, c'est une reaffectation. Le banc refuse desormais tout nom declare deux
     fois dans ce fichier. */
  var TEINTES_BORD = (function () {
    try {
      var el = document.querySelector("[data-gw-fonds]");
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  })();
  function teinteBordPar(id) {
    return TEINTES_BORD.filter(function (f) { return f.id === id; })[0] || TEINTES_BORD[0] || null;
  }

  var SUPPORT = "papier";
  function estMetal() { return SUPPORT === "metal"; }
  function formatsDuSupport() { return estMetal() ? FORMATS_METAL : FORMATS; }
  function roleFmt() { return estMetal() ? ROLE_FMT_METAL : ROLE_FMT; }
  function cmDe(f) { return (estMetal() ? METAL_CM : A_CM)[f] || null; }
  /* Le ratio de TOUTES les œuvres du catalogue (règle 1 du dépôt : 0,6923, atteint par
     compression, jamais par recadrage). Aucun des quatre formats de papier ne vaut ça :
     0,700 / 0,714 / 0,750 / 0,700. C'est cet écart qui faisait apparaître du blanc. */
  var RATIO_OEUVRE = 0.6923;
  /* Les trois couleurs du produit « Cadre pour affiche ». « Marron clair » et
     « Marron foncé » etaient proposes ici sans exister au catalogue. */
  var FRAME_SWATCH = { "Blanc": "#F2EFE9", "Noir": "#1A1A1A", "Chêne clair": "#D0AE79" };
  var FRAMES = ["Sans cadre", "Blanc", "Noir", "Chêne clair"];
  var NO_FRAME = "Sans cadre";
  var MAT_RATIO = 0.022;          // passe-partout : 2,2 % de la largeur de l'affiche (cf. #pdp-frame)
  /* Largeur de moulure, en cm réels. Ramenée de 1,6 à 1,0 : sur l'aperçu le cadre mangeait
     l'affiche, surtout depuis le grossissement mobile qui l'agrandit lui aussi. Les cadres
     fins sont d'ailleurs ceux qu'on vend — une baguette de 16 mm est une moulure de
     galerie, pas un encadrement d'affiche. */
  var MOULDING_CM = 1.0;

  /* ---- Géométrie du mur ----
     Plus de « taille » globale : la composition pose un FORMAT PAR DÉFAUT sur chaque
     emplacement (via les rôles s/m/l), et chaque affiche est ensuite redimensionnable
     individuellement (state.slotFmt). Les rôles ne servent donc qu'à choisir le format
     de départ de chaque emplacement. */
  var FORMATS = ["70X100", "50X70", "30X40", "21X30"];   // du plus grand au plus petit
  /* Formats de depart. Au-dessus d'un canape, le mur libre de la photo fait environ
     88 cm : un 70x100 seul n'y tient pas. Les roles visent donc plus bas, et le
     client agrandit emplacement par emplacement s'il le veut. */
  var ROLE_FMT = { s: "21X30", m: "30X40", l: "50X70" };
  var GAP_CM = 5;                 // écart entre affiches (l'usage : 5 à 8 cm)

  /* ---- Photo de situation (mockup-salon2) ----
     Le fond est la même scène carrée que l'image 2 des fiches produit. Les affiches sont
     ancrées dans WALL, une boîte définie sur la zone de mur propre de la photo
     (fractions du plateau carré). PHOTO 1400×1400. */
  var PHOTO_W = 1400, PHOTO_H = 1400;
  /* Desktop : ~20 % moins haut (on rogne le bas / canapé). Mobile garde le carré.
     Conservé pour mémoire du cadrage d'avant le resserrage ci-dessous. */
  var DESKTOP_CROP_H = 1120;
  var MQ_DESKTOP = window.matchMedia("(min-width: 981px)");
  /* Même seuil que le rail horizontal des murs prêts, côté CSS. */
  var MQ_RAIL = window.matchMedia("(max-width: 749px)");
  /* VUE : la portion de la photo réellement montrée, en fractions du carré 1400².
     Desktop, on ne rogne que le bas (le canapé). Mobile, on rogne AUSSI les côtés : sur
     375 px de large, la scène entière réduisait les affiches à des timbres — on ne voyait
     plus ce qu'on compose. Le cadrage resserre sur le mur en gardant assez d'étagère et
     de canapé pour donner l'échelle.
     Second resserrage : à w .72 les affiches restaient trop petites pour qu'on juge une
     composition sur un téléphone. À .56, la vue tient sur le pan de mur et ce qu'il faut
     de canapé pour l'échelle.

     ⚠️ Les valeurs sont liées au CSS de #gw-wall (aspect-ratio, background-size et
     background-position) : changer l'une sans l'autre décale les cadres du décor.
     background-size = 100/w ; position x = x/(1-w) ; position y = y/(1-h). */
  var VUE_MOBILE = { x: 0.20, y: 0.02, w: 0.56, h: 0.44 };
  /* Desktop : la scène entière était montrée en largeur (w = 1). Or le pan de mur ne fait que
     0,44 du plateau : les affiches n'occupaient donc que 44 % de la largeur affichée, et on
     jugeait sa composition de loin, comme depuis l'autre bout de la pièce.
     w .76 porte cette part à 58 %, soit un tiers de plus, sans perdre ce qui donne l'échelle :
     à x .12 la bibliothèque reste visible sur sa moitié droite (elle va jusqu'à .235), le pied
     de lampe (.705) et le rideau tiennent dans le champ, et h .608 garde le haut du canapé
     (.42). C'est un resserrage, pas un gros plan : sans le décor, une affiche sur un mur nu ne
     dit plus rien de sa taille.
     h suit w pour garder la forme du plateau : .76 / 1,25 = .608, le même rapport qu'avant. */
  var VUE_DESKTOP = { x: 0.12, y: 0, w: 0.76, h: 0.608 };
  function vue() {
    return MQ_DESKTOP.matches ? VUE_DESKTOP : VUE_MOBILE;
  }
  /* Zone mur = les 3 lames de bois (fractions du plateau CARRÉ 1400²).
     Mesures : etagere → ~0.23 ; lames ~0.23–0.78 (coutures 0.42 / 0.60) ;
     haut des coussins ~0.42 (le iy PDP 0.46 est le corps du canape, trop bas —
     bottom 0.445 faisait tasser Grille/Quintette/Galerie sur le dossier).
     bottom 0.355 laisse ~4 cm visuels au-dessus des coussins. Sur desktop,
     wallBox() renormalise top/bottom sur la hauteur rognee.

     ⚠️ right 0.70 et non 0.76 : le pied de lampe est un objet de PREMIER PLAN, son
     abat-jour commence à x≈0.705 et mord sur le mur exactement à la hauteur des
     cadres. À 0.76 les compositions larges (Trio, Quintette) posaient la dernière
     affiche par-dessus la lampe. left passe à 0.26 pour rendre au groupe la largeur
     perdue sans revenir sur l'étagère (bord à ~0.235). Les fractions sont
     horizontales : la correction vaut aussi bien sur mobile, où seul le rognage
     vertical diffère. */
  var WALL = { left: 0.26, right: 0.70, top: 0.08, bottom: 0.355 }; /* wall-calib-2026-07-28 */
  /* La zone mur, ramenée en fractions de ce qui est AFFICHÉ. */
  function wallBox() {
    var v = vue();
    return {
      left: (WALL.left - v.x) / v.w,
      right: (WALL.right - v.x) / v.w,
      top: (WALL.top - v.y) / v.h,
      bottom: (WALL.bottom - v.y) / v.h
    };
  }
  var FIT = 0.96;                 // marge : la composition ne touche jamais le bord de la zone
  /* Échelle réelle. La photo est un plan « mur » : la largeur visible de l'image
     représente WALL_CM de mur réel. Repère : le canapé (dossier ~200 cm, à plat
     contre le mur) occupe l'essentiel du cadre → la pleine largeur de la photo
     vaut ~260 cm. De là, chaque affiche est dimensionnée par son format réel (cm),
     donc un 70×100 paraît grand et un 21×30 petit, à l'échelle de la pièce. */
  var WALL_CM = 260;

  /* Chaque composition est une liste de RANGÉES. Une rangée est centrée
     horizontalement, ses affiches sont centrées verticalement entre elles : c'est
     ce centrage qui produit tout seul l'effet « escalier » quand les formats
     diffèrent (s / l / s), sans une seule coordonnée écrite à la main. */
  var LAYOUTS = [
    { id: "duo",       name: "Duo",        rows: [["m", "m"]] },
    { id: "trio",      name: "Trio",       rows: [["m", "m", "m"]] },
    /* ⛔ « PAIRE XL » RETIREE (Adrien, 29/08/2026 : « ca duplique "duo" »). Elle proposait deux
       affiches cote a cote comme le duo, a un cran de taille pres : sur une rangee de sept
       choix, deux entrees qui donnent la meme composition font hesiter sans rien apporter, et
       la taille se regle de toute facon affiche par affiche, juste en dessous.
       ⚠️ RIEN D'AUTRE NE LA CITAIT : aucun mur pret, aucune entree de `PAR_NOMBRE`, aucune
       locale. Et une composition sauvegardee dans un navigateur sur cet identifiant retombe sur
       le duo par `layoutById`, qui replie sur le premier choix quand l'identifiant est inconnu.
       Verifie avant de retirer, pas apres. */
    { id: "triptyque", name: "Triptyque",  rows: [["s", "l", "s"]] },
    { id: "grille",    name: "Grille",     rows: [["m", "m"], ["m", "m"]] },
    { id: "quintette", name: "Quintette",  rows: [["s", "l", "s"], ["m", "m"]] },
    { id: "galerie",   name: "Galerie",    rows: [["m", "m", "m"], ["m", "m", "m"]] }
  ];

  /* Murs prêts. Le composeur partait sur une page blanche : on demandait au client de
     faire le travail d'un décorateur avant de pouvoir acheter. Ces compositions sont
     construites depuis la classification du catalogue — même palette, même valeur, même
     REGISTRE. La palette seule ne suffisait pas : elle produisait un « mur bohème »
     mêlant photo, collage et aquarelle. Régénérables par catalogue/murs.js côté runway.

     Chaque mur donne SIX affiches, pas le nombre d'emplacements de sa disposition :
     Galerie en compte six, et sans cette réserve, agrandir la composition obligeait à
     répéter une affiche déjà accrochée. Deux fois la même image sur un mur se voit. */
  var MURS = [
    { id: "japandi-trio", name: "Trio japandi", layout: "triptyque", handles: ["affiche-botanique-branches-dolivier-au-vase-raye", "affiche-paris-la-muse-et-linstitut", "affiche-corse-la-passante-et-le-village-de-pierre", "affiche-cocktail-trois-olives-trait-net", "affiche-cocktail-le-verre-visage", "affiche-montagne-versant-lumineux"] },
    { id: "bord-de-mer", name: "Horizon marin", layout: "trio", handles: ["affiche-ibiza-profil-au-soleil-sepia", "affiche-ibiza-sunset-drift", "affiche-martinique-ile-bleue-en-aplats", "affiche-bretagne-phare-sur-roches-roses-vent-sale", "affiche-art-vagues-indigo-entre-les-rochers", "affiche-japon-fuji-vagues-pins-voile"] },
    { id: "scandi-duo", name: "Duo scandinave", layout: "duo", handles: ["affiche-montagne-chemin-vers-l-altitude", "affiche-montagne-souffle-des-cimes", "affiche-fruits-decoupes-nettes-bleu-et-sable", "affiche-fruits-formes-geometriques-nettes-sarcelle", "affiche-oiseaux-atelier-des-vents-oiseaux-geometriques", "affiche-botanique-trio-vases-bleus-minimalistes"] },
    { id: "boheme-quintette", name: "Mur bohème", layout: "quintette", handles: ["affiche-cocktail-negroni-sur-fond-corail", "affiche-cocktail-en-fete-mithila", "affiche-chat-le-chat-love-sur-le-tissage-geometrique", "affiche-chat-le-chat-calico-au-trait-d-encre-et-soleil-rouge", "affiche-william-morris-motif-cray-aux-pivoines", "affiche-portrait-matinee-au-cafe-morning-note"] },
    { id: "mediterranee", name: "Échappée méditerranéenne", layout: "trio", handles: ["affiche-marseille", "affiche-marseille-aplats-geometriques", "affiche-corse-les-perdrix-et-le-clocher-sur-le-golfe", "affiche-corse-le-village-en-camaieu-bleu", "affiche-corse-la-cote-en-carreaux-bleus", "affiche-chat-le-chat-turquoise-et-l-aperitivo-au-citron"] },
    { id: "retro-grille", name: "Grille rétro", layout: "grille", handles: ["affiche-paris-la-promeneuse-en-noir", "affiche-paris-lescalier-de-montmartre", "affiche-cocktail-le-symposion-antique", "affiche-cocktail-la-dame-au-damier", "affiche-montagne-lumiere-froide", "affiche-chat-le-chaton-au-ruban-sur-le-tabouret"] },
    { id: "noir-blanc", name: "Galerie noir & blanc", layout: "galerie", handles: ["affiche-paris-sous-larche-la-brume", "affiche-paris-le-quai-en-eau-forte", "affiche-corse-un-jour-de-juillet-sur-la-falaise", "affiche-corse-le-chemin-du-village-sous-les-cimes", "affiche-corse-le-corse-au-beret", "affiche-cocktail-la-coupe-sur-le-gueridon"] },
    { id: "botanique", name: "Mur botanique", layout: "trio", handles: ["affiche-botanique-branches-dolivier-au-vase-raye", "affiche-corse-immortelles-au-dessus-du-golfe", "affiche-corse-le-village-en-camaieu-bleu", "affiche-bruxelles-le-parc-en-toile-bleue", "affiche-bruxelles-elegantes-au-belvedere", "affiche-arbre-contour-continu-et-aplat-unique"] }
  ];

  var root = $("[data-gw]");
  if (!root) return;

  var state = {
    layout: LAYOUTS[0].id,
    mur: null,         // mur prêt en cours : sa réserve comble les emplacements ajoutés
    frame: NO_FRAME,   // cadre PAR DÉFAUT : sans cadre — on ne facture pas un cadre non demandé
    /* ⛔ « SANS » PAR DEFAUT, comme la fiche depuis le 22/08/2026, et pour la meme raison : le
       defaut du site doit etre ce que le site MONTRE. Un avis 2 etoiles du 17/08 disait
       exactement cela — « sur le site, l'image du poster etait presentee sans cadre blanc
       autour ; a la reception, j'ai decouvert qu'un cadre blanc avait ete ajoute ». */
    /* ⛔⛔ LA BORDURE SE CHOISIT PAR AFFICHE (Adrien, 28/08/2026 : « le choix de la bordure se
       fait au niveau de chaque affiche, et on doit pouvoir choisir la couleur de la bordure »).
       Un mur melange des sujets : une marge qui sert une aquarelle claire etouffe une affiche
       sombre d'a cote. Le cadre se choisit deja par emplacement, et pour la meme raison.
       ⚠️ UNE SEULE VALEUR PORTE LES DEUX DECISIONS : `null` = pas de bordure, une chaine = une
       bordure de cette teinte (`""` etant le papier nu). Deux etats separes — « avec/sans » d'un
       cote, la couleur de l'autre — se contredisent des qu'on en change un seul, et c'est
       toujours celui qu'on ne relit pas qui part au panier. */
    slotBord: {},
    arts: {},          // index d'emplacement -> produit normalisé
    slotFrames: {},    // index d'emplacement -> cadre personnalisé (override de state.frame)
    slotFmt: {},       // index d'emplacement -> format personnalisé (override du format de la composition)
    /* ⛔ CE QUE LE CLIENT A CHOISI LUI-MÊME, par opposition à ce que la page a posé pour lui.
       C'est la seule chose qui distingue un emplacement qu'on a le droit de rafraîchir d'un
       emplacement qu'on doit laisser tranquille. Sans cette distinction, le garde-fou
       « ne rien écraser » protégeait aussi la proposition de la machine : le tout premier
       remplissage automatique s'enregistrait (render() finit par save()), et la fonction ne
       jouait donc qu'UNE FOIS PAR NAVIGATEUR, à vie. */
    choisis: {},       // index d'emplacement -> true si le client y a mis la main
    /* La teinte du mur affiche. « fond » et non « mur » : state.mur designe deja les murs
       PRETS (compositions toutes faites), et recycler le mot aurait fini en confusion. */
    fond: (FONDS[0] && FONDS[0].cle) || "beige"
  };
  var STORE_KEY = "affichely:composition";
  /* ⚠️ Lu MAINTENANT, avant le premier render(). render() se termine par save() : un
     premier rendu à l'état par défaut écrasait la composition sauvegardée avant même
     que restore() ne la lise. Le mur revenait vide à CHAQUE rafraîchissement, quelles
     que soient les affiches. C'est la cause première ; le fait que restore() cherchait
     les affiches dans les collections du sélecteur en était une seconde. */
  var SAUVEGARDE = (function () {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || "null"); } catch (e) { return null; }
  })();

  /* Cadre effectif d'un emplacement : sa personnalisation, sinon le défaut global. */
  function frameOf(i) { return state.slotFrames[i] || state.frame; }
  /* `null`/`undefined` = pas de bordure. Une chaine = une bordure de cette teinte, `""` etant le
     papier nu. Voir `state.slotBord` pour ce que porte cette valeur unique. */
  function bordOf(i) { var v = state.slotBord[i]; return v === undefined ? null : v; }

  /* ---------- Géométrie ---------- */
  function layoutById(id) { return LAYOUTS.filter(function (l) { return l.id === id; })[0] || LAYOUTS[0]; }

  /* Renvoie { w, h, slots:[{x,y,w,h,fmt}] } en centimètres. Le format de chaque
     emplacement = son override (state.slotFmt), sinon le format de départ de son rôle. */
  function geometry() {
    var L = layoutById(state.layout);
    var idx = 0;
    var rows = L.rows.map(function (roles) {
      var items = roles.map(function (r) {
        var f = state.slotFmt[idx] || roleFmt()[r];
        var d = cmDe(f);
        var iSlot = idx;
        idx++;
        /* ⚠️ LARGEUR DÉDUITE DU RATIO DE L'ŒUVRE, pas de celle du papier.
           Un 30×40 a un ratio de 0,75, l'œuvre de 0,6923 : posée en « contain » sur un
           emplacement au ratio du papier, elle laissait 3,4 px de feuille blanche à gauche et
           à droite, et deux traits sur les côtés se lisent comme un défaut d'affichage, pas
           comme une marge de tirage. L'emplacement prend donc le ratio de l'œuvre : elle le
           remplit bord à bord, sans rognage ni déformation, exactement comme la fiche produit
           la montre.
           La HAUTEUR reste celle du format réel : un 70×100 domine toujours un 21×30, et
           l'échelle du mur ne bouge pas. Seule la largeur se resserre de quelques pour cent.

           ⛔ ET LE CADRE S'AJOUTE AUTOUR, IL NE SE PRÉLÈVE PAS DESSUS.
           Le carton et la moulure étaient retirés de l'oeuvre : on soustrayait la MÊME épaisseur
           en haut, en bas et sur les côtés d'un rectangle qui n'est pas carré, ce qui donne une
           fenêtre au rapport 0,6829 au lieu de 0,6923. L'oeuvre, posée en `contain` dedans, se
           calait alors sur la largeur et laissait du blanc en haut et en bas EN PLUS du carton :
           le passe-partout paraissait une fois et demie plus épais en haut qu'sur les côtés.
           Signalé le 31/07/2026 sur la vue composeur.
           Un vrai cadre s'ajoute autour du tirage. L'emplacement fait donc l'oeuvre PLUS deux
           fois le carton PLUS deux fois la moulure, sur les deux axes : la fenêtre garde
           exactement le rapport de l'oeuvre, et les quatre marges sont égales en pixels comme
           elles le sont en centimètres.
           Sans cadre, rien ne s'ajoute : l'emplacement vaut l'oeuvre, bord à bord.

           ⛔ CE RATIO N'EST PLUS UNIQUE DEPUIS LES AFFICHES PAYSAGE (Adrien, 20/09/2026 :
           « bug sur le composer au format paysage »). `RATIO_OEUVRE` supposait TOUTE oeuvre
           portrait ; une paysage (largeur > hauteur) posee avec ce seul ratio recevait un
           emplacement trop haut, et `object-fit: contain` y laissait deux bandes blanches au
           lieu du bord a bord. Le ratio vient maintenant de l'oeuvre choisie sur CET
           emplacement (`state.arts[iSlot].ratio`, lu depuis l'image Shopify — voir `normalize`
           et `ratioDe`), avec `RATIO_OEUVRE` en repli pour un emplacement vide ou sans donnee.
           Un ratio > 1 est paysage : c'est alors la LARGEUR qui vaut le grand cote du format
           (d[1]), pour garder la meme regle qu'au portrait — « le grand cote domine toujours
           le petit format », quel que soit l'axe sur lequel il tombe. */
        var art = state.arts[iSlot];
        var ratioOeuvre = (art && art.ratio) || RATIO_OEUVRE;
        var wArt, hArt;
        if (ratioOeuvre > 1) { wArt = d[1]; hArt = d[1] / ratioOeuvre; }
        else { wArt = d[1] * ratioOeuvre; hArt = d[1]; }
        var bord = frameOf(iSlot) === NO_FRAME ? 0 : (MAT_RATIO * wArt + MOULDING_CM);
        return { fmt: f, w: wArt + 2 * bord, h: hArt + 2 * bord };
      });
      var w = items.reduce(function (a, i) { return a + i.w; }, 0) + GAP_CM * (items.length - 1);
      var h = items.reduce(function (a, i) { return Math.max(a, i.h); }, 0);
      return { items: items, w: w, h: h };
    });
    var W = rows.reduce(function (a, r) { return Math.max(a, r.w); }, 0);
    var H = rows.reduce(function (a, r) { return a + r.h; }, 0) + GAP_CM * (rows.length - 1);

    var slots = [], y = 0;
    rows.forEach(function (row) {
      var x = (W - row.w) / 2;
      row.items.forEach(function (it) {
        slots.push({ x: x, y: y + (row.h - it.h) / 2, w: it.w, h: it.h, fmt: it.fmt });
        x += it.w + GAP_CM;
      });
      y += row.h + GAP_CM;
    });
    return { w: W, h: H, slots: slots };
  }

  /* Place la composition sur le mur À L'ÉCHELLE RÉELLE : chaque cm réel vaut
     1/WALL_CM de la largeur du plateau (dérivé du repère canapé). On dimensionne donc
     la composition d'après ses cm réels — un 70×100 est grand, un 21×30 petit. Si une
     grande composition déborde de la zone « mur », on réduit UNIFORMÉMENT tout le
     groupe (clamp) pour qu'il reste sur le mur : les tailles RELATIVES restent
     justes, seule l'échelle absolue est bridée dans ce cas extrême. */
  /* Fraction de la largeur AFFICHÉE que vaut un cm réel. La photo entière représente
     WALL_CM ; une vue resserrée n'en montre que v.w, donc le même cm y occupe plus de
     place.

     ⚠️ Sur mobile, resserrer la vue ne suffisait pas : à l'échelle réelle une 30×40 dans
     145 cm de mur visible fait 68 px de large sur un écran de 375. Le rendu à l'échelle
     est un argument sur DESKTOP, où l'on compare l'affiche au canapé ; sur un téléphone,
     ce qu'on regarde c'est l'affiche. On grossit donc la composition d'un facteur fixe.
     Les tailles RELATIVES entre formats restent exactes — un 70×100 reste 2,3 fois plus
     large qu'un 21×30 — seule l'échelle absolue par rapport à la pièce est forcée. Le
     clamp de placement() empêche les grandes compositions de sortir du mur. */
  var GROSSISSEMENT_MOBILE = 1.45;
  function pxpcm() {
    return (MQ_DESKTOP.matches ? 1 : GROSSISSEMENT_MOBILE) / (WALL_CM * vue().w);
  }
  function placement(geo) {
    if (roomBackground && roomBackground.current()) return roomBackground.placement(geo);
    var PXPCM_W = pxpcm();
    var w = wallBox();
    var v = vue();
    var ar = (v.w * PHOTO_W) / (v.h * PHOTO_H); // largeur / hauteur de la vue
    var bw = w.right - w.left;               // largeur de la zone (fraction largeur plateau)
    var bh = w.bottom - w.top;               // hauteur de la zone (fraction hauteur plateau)
    var compW = geo.w * PXPCM_W;             // largeur réelle en fraction de LARGEUR plateau
    var compH = geo.h * PXPCM_W * ar;        // hauteur réelle en fraction de HAUTEUR plateau
    var k = Math.min(1, bw * FIT / compW, bh * FIT / compH);  // clamp si débordement
    var effW = compW * k, effH = compH * k;
    return {
      k: k,
      clamped: k < 0.999,
      Cw: effW,                              // largeur composition en fraction de LARGEUR plateau
      compHfrac: effH,                       // hauteur composition en fraction de HAUTEUR plateau
      leftFrac: w.left + (bw - effW) / 2,    // centrée horizontalement dans la zone
      topFrac: w.top + (bh - effH) / 2       // centrée verticalement dans la zone
    };
  }

  /* ---------- Données produit ----------
     /collections/<handle>/products.json : endpoint public de la vitrine, aucune clé.
     limit=250 renvoie des 503 sur cette boutique — on pagine par 50, qui passe. */
  var cache = {};
  /* Filtres actifs du sélecteur : { "filter.p.m.custom.piece": ["Salon", "Bureau"] }.
     On les rejoue tels quels dans l'URL — ce sont les paramètres de Search & Discovery,
     les mêmes qu'une page collection. */
  var filtresActifs = {};
  var filtresDispo = [];

  /* Popularité : ventes puis vues, dans cet ordre. Les pages collection héritent du tri
     natif de Shopify, qui ne connaît que les ventes ; ici on contrôle le rendu, donc on
     applique la règle entière. Fichier séparé de l'index de palette : deux nombres par
     affiche n'ont pas à coûter 218 ko. Absent ou en échec, le tri retombe sur l'ordre
     rendu par la collection — jamais d'écran vide pour un fichier annexe. */
  var POP = null;
  function chargerPop() {
    if (POP) return Promise.resolve(POP);
    /* Le Studio d'abord, le fichier d'assets en secours : figé, il datait de trois jours et
       ne couvrait que 120 affiches sur 1 322 le 31/07/2026. */
    var u = (CFG.popularite || ""), r2 = (CFG.populariteRepli || "");
    if (!u && !r2) { POP = {}; return Promise.resolve(POP); }
    var lire = function (x) {
      if (!x) return Promise.reject();
      return fetch(x).then(function (r) { return r.ok ? r.json() : Promise.reject(); });
    };
    return lire(u).catch(function () { return lire(r2); })
      .then(function (d) { POP = (d && d.pop) || {}; return POP; })
      .catch(function () { POP = {}; return POP; });
  }
  function trierParPopularite(l) {
    if (!POP) return l;
    var p = POP;
    return l.map(function (x, i) { return { x: x, i: i }; }).sort(function (a, b) {
      var A = p[a.x.handle] || [0, 0], B = p[b.x.handle] || [0, 0];
      if (B[0] !== A[0]) return B[0] - A[0];      // ventes
      if (B[1] !== A[1]) return B[1] - A[1];      // vues
      return a.i - b.i;                            // sinon l'ordre de la collection
    }).map(function (o) { return o.x; });
  }
  function chaineFiltres() {
    var q = "";
    Object.keys(filtresActifs).forEach(function (p) {
      (filtresActifs[p] || []).forEach(function (v) {
        q += "&" + encodeURIComponent(p) + "=" + encodeURIComponent(v);
      });
    });
    return q;
  }

  function fetchPage(handle, n, tries) {
    /* Prefixe de langue obligatoire : sans lui products.json repond dans la langue
       principale, et le module affichait des titres francais sur /en, /de, /es… */
    /* ⚠️ Vue `picker` (templates/collection.picker.liquid), pas products.json : ce dernier
       ignore les filtres et ne renvoie aucun métachamp, or les facettes des collections
       (Couleur, Thème, Pièce, Style…) SONT des métachamps. Seul Liquid peut les rendre. */
    /* ⚠️ `v=2` et `cache: no-cache` ne sont pas décoratifs. Avant l'existence de la vue
       picker, cette même URL renvoyait la page collection en HTML, et les navigateurs ont
       gardé cette réponse en cache : le sélecteur relisait un vieux corps sans `products`
       et affichait « Aucune affiche dans cette collection ». Le paramètre change la clé de
       cache, l'en-tête force la revalidation. À rebumper si le format de la vue change. */
    /* ⛔ REBUMPÉ À 3 LE 28/08/2026 : la vue emet desormais `plein`, le tarif barre. Sans ce
       changement de cle, le bord de Shopify aurait continue de servir un corps SANS le tarif —
       le badge de promo serait reste muet sur les affiches choisies, exactement le defaut qu'on
       vient de corriger, et la correction aurait eu l'air de ne pas marcher. */
    var url = murUrl("collections/") + encodeURIComponent(handle)
      + "?view=picker&v=3&page=" + n + chaineFiltres();
    /* ⚠️ AUCUN en-tête Accept. Shopify négocie le contenu sur les URL de collection : avec
       `Accept: application/json` il renvoie SA représentation de la collection
       — {"collection":{"id":…}}, 518 octets, sans produits — et ignore `view=picker`.
       L'en-tête venait de l'ancien appel à products.json, où il ne gênait pas. C'est lui
       qui vidait le sélecteur, pas le cache : la même URL sans en-tête rend 50 affiches. */
    return fetch(url, { cache: "no-cache" }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).catch(function (e) {
      /* La boutique renvoie des 503 intermittents : on réessaie avant d'abandonner. */
      if ((tries || 0) >= 2) throw e;
      return new Promise(function (res) { setTimeout(res, 600 * ((tries || 0) + 1)); })
        .then(function () { return fetchPage(handle, n, (tries || 0) + 1); });
    });
  }
  function normalize(p) {
    /* L'outil montre l'ŒUVRE, pas les mises en situation : -mur et -salon sont
       des photos de mur/salon qui contiennent déjà leur propre cadre.
       Le séparateur peut être `.` ou `_` : Shopify suffixe le fichier d'un `_<uuid>`
       quand le nom existe déjà sur le CDN, ce qui arrive à chaque remplacement de
       médias. Sans le `_`, le mockup salon passait pour l'œuvre. */
    var art = (p.images || []).filter(function (i) {
      return !/-mur[._]|-salon[._]/i.test(i.src);
    })[0] || (p.images || [])[0];
    if (!art) return null;
    var vmap = {};
    (p.variants || []).forEach(function (v) {
      /* products.json donne le prix en euros ("59.95"), pas en centimes comme /cart.js. */
      /* Une seule option sur une affiche : la taille. La cle incluait le cadre, qui
         n'est pas une option du produit mais un article a part. */
      /* ⛔⛔ LE TARIF VOYAGE AVEC LE PRIX (Adrien, 28/08/2026 : « on ne comprend pas que c'est en
         realite superieur a -10 % car le prix affiche est deja celui de la promo »). Le prix du
         catalogue est DEJA celui de la promo ; sans son prix barre, le recapitulatif ne peut
         comparer qu'a lui-meme, et il annonce la remise de lot seule — 10 % la ou le client
         economise 24 % du tarif. `compare_at_price` est nul hors promo : on retombe alors sur le
         prix, et le cumul vaut le palier, ce qui est exact. */
      var plein = parseFloat(v.compare_at_price || 0) * 100;
      var prix = Math.round(parseFloat(v.price) * 100);
      vmap[v.option1] = { id: v.id, cents: prix, plein: Math.max(prix, Math.round(plein || 0)),
        ok: v.available !== false };
    });
    /* ⛔ RATIO REEL DE L'OEUVRE, PAS UNE CONSTANTE UNIQUE. `art.width`/`art.height` viennent de
       l'image Shopify elle-meme : une affiche PAYSAGE (largeur > hauteur) a besoin de son
       propre ratio dans `geometry()`, sans quoi elle est posee comme un portrait et « contain »
       laisse deux bandes blanches. `null` retombe sur `RATIO_OEUVRE`, le portrait par defaut. */
    var ratio = (art.width && art.height) ? art.width / art.height : null;
    return { handle: p.handle, title: p.title, img: art.src, ratio: ratio, variants: vmap };
  }
  /* Meme ratio que `normalize()`, pour les affiches qui arrivent par le picker
     (collection/recherche) : `w`/`h` sont rendus par `templates/*.picker.liquid`,
     directement depuis l'image Shopify choisie. */
  function ratioDe(p) { return (p && p.w && p.h) ? p.w / p.h : null; }
  function loadCollection(handleBrut) {
    /* La clé de cache inclut les filtres : sans ça, filtrer sur Bleu puis retirer le
       filtre rendait la liste bleue, servie depuis le cache. */
    var handle = handleBrut;
    var cle = handle + chaineFiltres();
    /* Ne pas traiter [] comme « déjà en cache » : un 1er fetch vide (503 partiel,
       mauvaise poignée…) bloquait le picker sur l’état « Aucune affiche… « » ». */
    if (Object.prototype.hasOwnProperty.call(cache, cle) && cache[cle].length) {
      return Promise.resolve(cache[cle]);
    }
    var out = [];
    function page(n) {
      return fetchPage(handle, n, 0).then(function (d) {
        /* La vue picker renvoie les affiches DÉJÀ normalisées et les filtres calculés par
           Shopify pour les paramètres envoyés : on les prend tels quels. */
        if (d.filters) filtresDispo = d.filters;
        /* Une réponse sans `products` n'est pas une collection vide : c'est une autre
           réponse. On le dit dans la console plutôt que d'afficher « aucune affiche », qui
           envoie chercher le problème du mauvais côté. */
        if (!d || !Array.isArray(d.products)) {
          console.warn("gallery-wall : réponse inattendue pour " + handle, Object.keys(d || {}));
        }
        var ps = d.products || [];
        out = out.concat(ps);
        if (ps.length === 50 && n < (d.pages || 1) && n < 6) return page(n + 1);
      });
    }
    return page(1).then(function () {
      var list = out.filter(function (p) { return p && p.handle && p.img; });
      list.forEach(function (p) { p.ratio = ratioDe(p); });
      if (list.length) cache[cle] = list;
      else delete cache[cle];
      return list;
    });
  }

  /* La recherche interroge TOUTE la boutique, pas l'onglet courant.
     Avant, le champ filtrait en JavaScript la page déjà chargée : taper « marseille » dans
     Voyage ne regardait que les cinquante affiches reçues pour cet onglet. La boutique en a
     davantage, et certaines ne sont pas dans Voyage — le client voyait trois résultats et en
     concluait qu'il n'y avait que trois affiches de Marseille.
     C'est maintenant le moteur de la boutique qui répond, celui de la barre du haut : mêmes
     tolérances (pluriels, accents, synonymes) et tout le catalogue. */
  var cacheRecherche = {};
  function loadRecherche(q) {
    if (cacheRecherche[q]) return Promise.resolve(cacheRecherche[q]);
    var out = [];
    function page(n) {
      /* Meme rebump que la vue collection, pour la meme raison : le tarif est neuf. */
      var url = murUrl("search") + "?view=picker&v=2&type=product&page=" + n
        + "&q=" + encodeURIComponent(q);
      /* Pas d'en-tête Accept, même piège que les collections : Shopify négocierait le
         contenu et renverrait autre chose que la vue demandée. */
      return fetch(url, { cache: "no-cache" }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (d) {
        var ps = d.products || [];
        out = out.concat(ps);
        if (ps.length === 50 && n < (d.pages || 1) && n < 4) return page(n + 1);
      });
    }
    return page(1).then(function () {
      var list = out.filter(function (p) { return p && p.handle && p.img; });
      list.forEach(function (p) { p.ratio = ratioDe(p); });
      if (list.length) cacheRecherche[q] = list;
      return list;
    });
  }

  /* Une affiche seule, par son handle. Le picker charge des collections entières ; les
     murs prêts désignent des affiches précises, et products.json ne sait pas filtrer.
     Même normalize() des deux côtés : un mur prêt et un choix manuel produisent
     exactement le même objet, donc le reste du composeur ne voit pas la différence. */
  var cacheArt = {};
  function loadArt(handle) {
    if (cacheArt[handle]) return Promise.resolve(cacheArt[handle]);
    return fetch(murUrl("products/") + encodeURIComponent(handle) + ".json",
                 { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var a = d && d.product ? normalize(d.product) : null;
        if (a) cacheArt[handle] = a;
        return a;
      })
      .catch(function () { return null; });
  }

  /* ⛔ UN MUR PROPOSE PAR UNE PAGE, PAR L'URL (Adrien, 16/08/2026 : depuis l'article
     mediterraneen, « Composer mon mur » doit arriver avec six best sellers deja poses). Une page
     blanche apres un article qui vient de montrer douze affiches, c'est demander au lecteur de
     refaire le travail qu'il vient de lire.

     ⚠️ DES HANDLES, PAS DES IDENTIFIANTS PRODUIT. Adrien a demande « les product_id », mais le
     composeur ne parle qu'aux endpoints PUBLICS de la vitrine, qui ne connaissent pas les
     identifiants numeriques : `loadArt` prend un handle, et c'est deja la cle de tout le reste du
     fichier (MURS, recents, sauvegarde). Passer des identifiants imposerait un aller-retour
     serveur pour les traduire, a chaque ouverture.

     ⚠️ RIEN N'EST CODE EN DUR ICI : n'importe quel article pourra proposer sa selection sans
     qu'on retouche le theme. La disposition se deduit du NOMBRE d'affiches si elle n'est pas
     donnee, sans quoi une liste de six arrivant en duo perdrait quatre affiches en silence. */
  var PAR_NOMBRE = { 2: "duo", 3: "trio", 4: "grille", 5: "quintette", 6: "galerie" };

  /* ⛔ LA BARRE D'ADRESSE N'EST PAS TOUJOURS L'URL DE CE QU'ON REGARDE.
     Ouvert depuis un article, le composeur est POSE DANS la page de l'article par
     `modale-creation.js` : il n'y a aucune navigation, donc `location.search` reste celui de
     l'article, vide de tout `?affiches=`. Le composeur croyait a une arrivee ordinaire et
     reposait les dernieres affiches consultees a la place des six proposees (Adrien,
     16/08/2026) ; sur un navigateur neuf le defaut ne se voyait pas, faute d'affiches
     recentes a poser.
     La modale declare l'URL qu'elle a chargee ; c'est elle qui fait foi quand elle existe.
     ⚠️ Meme famille que `window.__creationSource`, pose deux lignes plus loin dans ce
     fichier-la, et pour la meme raison : sans navigation, rien de ce qui decrit « d'ou on
     vient » n'est lisible dans le document hote. */
  function requeteAffichee() {
    var m = window.__creationUrl;
    if (m) { try { return new URL(m, location.href).search; } catch (e) {} }
    return window.location.search;
  }

  /* ⛔⛔ LE SUPPORT SE LIT DANS L'ADRESSE, comme le mur propose et pour la meme raison : le
     composeur s'ouvre dans une MODALE, sans navigation, donc `location.search` reste celui de la
     page hote. `requeteAffichee` est le seul endroit qui sait ou regarder ; s'en passer ici
     aurait rendu le support invisible depuis une fiche, c'est-a-dire dans le seul cas qui
     compte. */
  function lireSupport() {
    var q;
    try { q = new URLSearchParams(requeteAffichee()); } catch (e) { return; }
    SUPPORT = String(q.get("support") || "").trim() === "metal" ? "metal" : "papier";
  }

  function murDepuisUrl() {
    var q;
    try { q = new URLSearchParams(requeteAffichee()); } catch (e) { return null; }
    var brut = (q.get("affiches") || "").trim();
    if (!brut) return null;
    // La chaine vient de l'exterieur : on filtre sur la forme d'un handle, on ne fait pas confiance.
    var handles = brut.split(",").map(function (h) { return String(h || "").trim().toLowerCase(); })
      .filter(function (h) { return /^[a-z0-9-]{3,120}$/.test(h); })
      .slice(0, 6);
    if (!handles.length) return null;
    var dispo = String(q.get("dispo") || "").trim();
    if (!LAYOUTS.some(function (l) { return l.id === dispo; })) {
      dispo = PAR_NOMBRE[handles.length] || "trio";
    }
    return { id: "url", name: "Mur proposé", layout: dispo, handles: handles };
  }

  function applyPreset(id) {
    var M = MURS.filter(function (x) { return x.id === id; })[0];
    if (!M) return;
    state.mur = id;
    state.layout = M.layout;
    state.arts = {}; state.slotFrames = {}; state.slotFmt = {};
    selectedSlot = null;
    render();                                   // la disposition apparaît tout de suite
    var n = geometry().slots.length;
    Promise.all(M.handles.slice(0, n).map(loadArt)).then(function (arts) {
      arts.forEach(function (a, i) { if (a) state.arts[i] = a; });
      render();
    });
  }

  function variantFor(art, fmt) {
    if (!art) return null;
    if (!estMetal()) return art.variants[fmt] || null;
    /* ⛔ EN METAL, LA CLE DU CATALOGUE PORTE UN MOT QU'ON NE CONNAIT PAS (Markets le traduit) :
       on retrouve la variante par son jeton numerique, la seule partie stable des treize
       marches. Voir `estCoteMetal` pour ce qui separe « 30x40 » de « <mot> 30x40 ». */
    var cle = Object.keys(art.variants).filter(function (k) {
      return estCoteMetal(k) && jetonCote(k) === fmt;
    })[0];
    return cle ? art.variants[cle] : null;
  }
  /* Cadre : produit distinct « cadre-pour-affiche », decline par taille et couleur,
     exactement comme l'upsell de la fiche produit. Une ligne de panier par cadre. */
  var FRAME_VARIANTS = (window.GW_CONFIG && window.GW_CONFIG.frameVariants) || [];
  /* Markets traduit les couleurs, tandis que les compositions sauvegardees gardent
     leurs cles francaises. Le rang du produit relie ces cles aux valeurs locales,
     comme sur la fiche produit, y compris quand une couleur est indisponible. */
  function frameColors() {
    var colors = [];
    FRAME_VARIANTS.forEach(function (v) {
      (v.options || []).forEach(function (o) {
        if (!/^\d+X\d+$/i.test(String(o)) && colors.indexOf(o) === -1) colors.push(o);
      });
    });
    return colors;
  }
  function frameLabel(color) {
    if (color === NO_FRAME) return t("no_frame", "Sans cadre");
    var rank = FRAMES.indexOf(color) - 1;
    return rank >= 0 ? (frameColors()[rank] || color) : color;
  }
  function frameVariantFor(fmt, color) {
    if (!color || color === NO_FRAME) return null;
    var localized = frameLabel(color);
    return FRAME_VARIANTS.filter(function (v) {
      return v.available !== false && (v.options || []).indexOf(fmt) > -1
        && (v.options || []).indexOf(localized) > -1;
    })[0] || null;
  }

  /* ---------- Rendu du mur ---------- */
  var stage = $("#gw-wall", root);
  var roomBackground = null;
  var scaleNote = $("[data-gw-scale]", root);
  var dock = $("[data-gw-dock]", root);
  var selectedSlot = null;

  function useDock() {
    if (roomBackground && roomBackground.current()) return true;
    return !!(window.matchMedia && (
      matchMedia("(hover: none)").matches || matchMedia("(max-width: 980px)").matches
    ));
  }

  function sizesHTML(i, fmt, art) {
    var unavail = t("unavailable", "indisponible");
    return '<div class="gw-slot__sizes" role="group" aria-label="' + esc(t("format", "Format")) + '">' +
      formatsDuSupport().map(function (f) {
        var avail = !art || !!variantFor(art, f);
        return '<button type="button" class="gw-slot__sz" data-slot-fmt="' + i + '"' +
          ' data-fmt="' + f + '"' +
          ' aria-pressed="' + (f === fmt ? "true" : "false") + '"' +
          (avail ? "" : " disabled aria-disabled=\"true\"") +
          ' title="' + f + (avail ? "" : " · " + unavail) + '"' +
          ' aria-label="' + esc(t("format", "Format")) + " " + f + (avail ? "" : ", " + unavail) + '">' + f + "</button>";
      }).join("") + "</div>";
  }

  function framesHTML(i, fmt, frame) {
    var unavail = t("unavailable", "indisponible");
    return '<div class="gw-slot__frames" role="group" aria-label="' + esc(t("frame", "Cadre")) + '">' +
      FRAMES.map(function (f) {
        var avail = f === NO_FRAME || !!frameVariantFor(fmt, f);
        var label = frameLabel(f);
        var dot = f === NO_FRAME
          ? '<span class="gw-slot__swdot gw-slot__swdot--none"></span>'
          : '<span class="gw-slot__swdot" style="background:' + FRAME_SWATCH[f] + '"></span>';
        return '<button type="button" class="gw-slot__sw" data-slot-frame="' + i + '"' +
          ' data-frame="' + esc(f) + '"' +
          ' aria-pressed="' + (f === frame ? "true" : "false") + '"' +
          (avail ? "" : " disabled aria-disabled=\"true\"") +
          ' title="' + esc(label) + (avail ? "" : " · " + unavail) + '"' +
          ' aria-label="' + esc(t("frame", "Cadre") + " " + label) + (avail ? "" : ", " + unavail) + '">' + dot + "</button>";
      }).join("") + "</div>";
  }

  /* ⛔⛔ UNE SEULE RANGEE PORTE LES DEUX DECISIONS : « pas de bordure » d'abord, puis les
     teintes. Deux rangees — un interrupteur avec/sans, un nuancier — se contredisent des qu'on
     touche a l'une : choisir une couleur sans allumer l'interrupteur ne fait rien, et c'est le
     genre de silence qui fait cliquer trois fois avant d'abandonner. Meme grammaire que les
     cadres, ou « Sans cadre » est la premiere pastille et non une case a cocher.
     ⚠️ LA PREMIERE PASTILLE DE COULEUR EST LE PAPIER NU, pas du blanc : son slug vaut `""`, rien
     ne part au panier, et la presse tire le blanc franc qu'elle tire depuis le 17/08. */
  /* ⚠️ LES DEUX LIBELLES SONT CEUX DE LA FICHE, LUS DANS LE DOM — pas deux nouvelles cles a
     traduire en treize langues pour dire ce que le site dit deja. `products.product.border_*`
     est traduit partout depuis le 22/08, et deux jeux de mots pour une seule option finissent
     par se contredire : la ligne du panier dirait « Sans bordure » et l'ecran « Aucune ». */
  function libBord(cle, repli) {
    var el = $("[data-gw-bordure-libelles]", root);
    return (el && el.getAttribute("data-" + cle)) || repli;
  }
  function bordsHTML(i, cur) {
    var sansLbl = libBord("sans", "Sans bordure");
    var sans = '<button type="button" class="gw-slot__sw gw-slot__sw--nobord" data-slot-bord="' + i + '"'
      + ' data-bord="" data-bord-non="1" aria-pressed="' + (cur === null ? "true" : "false") + '"'
      + ' title="' + esc(sansLbl) + '" aria-label="' + esc(sansLbl) + '">'
      + '<span class="gw-slot__swdot gw-slot__swdot--none"></span></button>';
    return '<div class="gw-slot__frames gw-slot__bords" role="group" aria-label="'
      + esc(libBord("titre", "Bordure")) + '">' + sans + TEINTES_BORD.map(function (f) {
        return '<button type="button" class="gw-slot__sw" data-slot-bord="' + i + '"'
          + ' data-bord="' + esc(f.id) + '"'
          + ' aria-pressed="' + (cur === f.id ? "true" : "false") + '"'
          + ' title="' + esc(f.nom) + '" aria-label="' + esc(f.nom) + '">'
          + '<span class="gw-slot__swdot" style="background:' + esc(f.hex) + '"></span></button>';
      }).join("") + "</div>";
  }

  function renderDock() {
    if (!dock) return;
    var n = geometry().slots.length;
    if (selectedSlot != null && selectedSlot >= n) selectedSlot = n ? n - 1 : null;
    if (selectedSlot == null || !useDock()) {
      dock.hidden = true;
      dock.innerHTML = "";
      return;
    }
    var geo = geometry();
    var s = geo.slots[selectedSlot];
    if (!s) { dock.hidden = true; dock.innerHTML = ""; return; }
    var art = state.arts[selectedSlot];
    var frame = frameOf(selectedSlot);
    dock.hidden = false;
    dock.innerHTML =
      '<div class="gw-slot-dock__head">' +
        /* ⛔ PLUS DE NUMERO D'EMPLACEMENT (Adrien, 24/08/2026 : « vire "emplacement 1",
           "emplacement 2", etc. »). Le dock est deja sous l'apercu, sur l'emplacement qu'on
           vient de toucher, et l'affiche choisie est encerclee : « EMPLACEMENT 1 » nommait ce
           que l'oeil voyait deja. Le libelle avait deja ete raccourci le 20/08 pour la meme
           raison ; il n'y a plus de raison de le garder du tout.
           ⚠️ `picker_slot_court` RESTE EN LOCALE ET RESTE UTILISE : le selecteur d'affiche s'en
           sert comme titre (voir `useDock()` plus bas). La cle n'est pas morte, seul cet
           affichage-ci disparait.
           ⚠️ ET LE LIBELLE D'ACCESSIBILITE DE CHAQUE EMPLACEMENT NE BOUGE PAS. Un lecteur
           d'ecran n'a ni l'encerclement ni la proximite pour savoir de quel emplacement on
           parle : retirer le mot VU ne veut pas dire retirer le mot DIT. */
        '<button type="button" class="gw-slot-dock__change" data-gw-dock-pick>' +
          (art ? t("change_art", "Changer l’affiche") : t("choose_art", "Choisir une affiche")) +
        "</button>" +
      "</div>" +
      '<div class="gw-slot-dock__row"><span class="gw-slot-dock__row-lbl">' + esc(t("format", "Format")) + "</span>" +
        sizesHTML(selectedSlot, s.fmt, art) + "</div>" +
      '<div class="gw-slot-dock__row"><span class="gw-slot-dock__row-lbl">' + esc(t("frame", "Cadre")) + "</span>" +
        framesHTML(selectedSlot, s.fmt, frame) + "</div>" +
      /* ⚠️ SUR TELEPHONE, LE DOCK EST LE SEUL ENDROIT OU L'ON REGLE UN EMPLACEMENT : les
         controles du mur ne s'ouvrent qu'au survol. Une bordure posee seulement sur le mur
         aurait ete inatteignable au doigt. */
      (art && !estMetal()
        ? '<div class="gw-slot-dock__row"><span class="gw-slot-dock__row-lbl">' + esc(libBord("titre", "Bordure")) + "</span>"
          + bordsHTML(selectedSlot, bordOf(selectedSlot)) + "</div>"
        : "");
  }

  function selectSlot(i) {
    selectedSlot = i;
    $$(".gw-slot", stage).forEach(function (el, idx) {
      el.classList.toggle("is-selected", idx === i);
    });
    renderDock();
  }

  function slotHTML(i, s, geo, pl) {
    var art = state.arts[i];
    var frame = frameOf(i);
    var none = frame === NO_FRAME;
    var col = none ? "transparent" : (FRAME_SWATCH[frame] || "#1A1A1A");

    /* ⛔⛔ LA BORDURE SE VOIT, SINON ELLE NE SE CHOISIT PAS. Un bouton qui ne change rien a
       l'ecran est un bouton dont personne ne sait ce qu'il fait — et c'est justement la marge
       blanche qui a values deux etoiles a une commande en aout.
       ⛔ LA GEOMETRIE VIENT DE `AfBordure`, la MEME table que la presse : recopier 15/20/25/35 mm
       ici ferait un apercu juste aujourd'hui et faux au premier ajustement.
       ⚠️ LARGEUR ET HAUTEUR EN POURCENTAGE, PAS UN `padding`. Un padding en pourcentage se
       resout sur la LARGEUR du parent, sur les deux axes : la marge du haut aurait suivi la
       largeur de la feuille, donc grandi sur un format allonge. Le piege est documente deux fois
       dans base.css, il n'avait pas besoin d'une troisieme.
       ⚠️ ET `partImage` REND `null` SUR UNE COTE INCONNUE — les cotes metal, par exemple, qui
       n'ont pas de bordure. On laisse alors l'affiche a fond perdu plutot que d'inventer une
       marge. */
    var styleArt = "", fondBord = "";
    var bd = bordOf(i);
    if (bd !== null && window.AfBordure && window.AfBordure.partImage) {
      /* ⛔ MEME BUG PAYSAGE QU'EN GEOMETRIE : `partImage` sait deja recevoir un second
         argument `paysage` (voir `pdp-configurator.js`), mais ne le recevait jamais ici. Sans
         lui il suppose un portrait et pose une bordure aux proportions inversees sur une
         oeuvre paysage. */
      var pb = window.AfBordure.partImage(s.fmt, art && art.ratio > 1);
      if (pb) {
        styleArt = ' style="width:' + pb.largeurPct.toFixed(3) + '%;height:'
          + pb.hauteurPct.toFixed(3) + '%;margin:auto"';
        var teinte = teinteBordPar(bd);
        fondBord = teinte ? teinte.hex : "#ffffff";
      }
    }
    var inner = art
      ? '<img class="gw-slot__art" src="' + esc(thumb(art.img, "600x")) + '"' + styleArt + ' alt="' + esc(art.title) + '" loading="lazy">' +
        '<span class="gw-slot__change" aria-hidden="true">' + esc(t("change_art", "Changer")) + "</span>"
      : '<span class="gw-slot__add" aria-hidden="true">' +
          '<svg class="gw-slot__plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>' +
          '<span class="gw-slot__hint">' + esc(t("add_slot", "Ajouter une affiche")) + "</span>" +
          '<span class="gw-slot__fmt">' + esc(s.fmt) + '</span>' +
        '</span>';

    var matLabel = art
      ? t("slot_filled", "__TITLE__ · __FMT__. Changer d’affiche").replace("__TITLE__", art.title).replace("__FMT__", s.fmt)
      : t("slot_empty", "Emplacement __N__ vide, __FMT__. Ajouter une affiche").replace("__N__", String(i + 1)).replace("__FMT__", s.fmt);

    /* ⚠️ LA TEINTE SE POSE SUR LA FEUILLE, PAS SUR L'EMPLACEMENT. L'emplacement porte deja le
       fond du CADRE : y ecrire la couleur de la bordure aurait peint la moulure. */
    var matBtn = '<button type="button" class="gw-slot__mat" data-slot="' + i + '"' +
      (fondBord ? ' style="background:' + esc(fondBord) + '"' : "") +
      ' aria-label="' + matLabel + '">' + inner + "</button>";

    /* Contrôles desktop (survol) : format, cadre, bordure. Mobile → dock. */
    var sizes = sizesHTML(i, s.fmt, art);
    var swatches = art ? framesHTML(i, s.fmt, frame) : "";
    var bords = art && !estMetal() ? bordsHTML(i, bd) : "";
    var ctrl = '<div class="gw-slot__ctrl">' + sizes + swatches + bords + "</div>";

    /* left/top/width/height posés ensuite par placeSlots() en px entiers. */
    return '<div class="gw-slot ' + (art ? "gw-slot--filled" : "gw-slot--empty") +
      (styleArt ? " gw-slot--bord" : "") +
      (selectedSlot === i ? " is-selected" : "") + '"' +
      (fondBord ? ' data-fond="' + esc(fondBord) + '"' : "") +
      ' style="left:0;top:0;width:0;height:0;background:' + col + ';padding:0"' +
      (none ? " data-noframe" : "") + ">" + matBtn + ctrl + "</div>";
  }

  /* Placement en pixels entiers, rangée par rangée.
     L'ancien snap (arrondir chaque getBoundingClientRect indépendamment) créait
     des écarts inégaux entre colonnes et un décalage global à gauche. */
  function placeSlots() {
    var geo = geometry(), pl = placement(geo);
    var sw = stage.clientWidth, sh = stage.clientHeight;
    if (!sw || !sh) return;
    if (roomBackground && roomBackground.current()) {
      $$(".gw-slot",stage).forEach(function(el,i){
        el.hidden=!pl;
        if(!pl)return;
        var slot=geo.slots[i],w=slot.w*10,h=slot.h*10;
        el.style.left=el.style.top='0px';el.style.width=w+'px';el.style.height=h+'px';
        el.style.padding=el.hasAttribute('data-noframe')?'0':MOULDING_CM*10+'px';
        el.style.transform=window.AfRoomGeometry.css(pl.slots[i],sw,sh,w,h);
      });
      calerArts();return;
    }

    var scaleX = (pl.Cw * sw) / geo.w;
    var scaleY = (pl.compHfrac * sh) / geo.h;
    var gapX = Math.max(1, Math.round(GAP_CM * scaleX));
    var gapY = Math.max(1, Math.round(GAP_CM * scaleY));
    var padMould = Math.max(2, Math.round(MOULDING_CM * scaleX));

    var L = layoutById(state.layout);
    var idx = 0;
    var rowMetas = L.rows.map(function (roles) {
      var items = roles.map(function () {
        var s = geo.slots[idx++];
        return {
          i: idx - 1,
          w: Math.max(1, Math.round(s.w * scaleX)),
          h: Math.max(1, Math.round(s.h * scaleY))
        };
      });
      return {
        items: items,
        w: items.reduce(function (a, it) { return a + it.w; }, 0) + gapX * Math.max(0, items.length - 1),
        h: items.reduce(function (a, it) { return Math.max(a, it.h); }, 0)
      };
    });

    var totalW = rowMetas.reduce(function (a, r) { return Math.max(a, r.w); }, 0);
    var totalH = rowMetas.reduce(function (a, r) { return a + r.h; }, 0) + gapY * Math.max(0, rowMetas.length - 1);

    var w = wallBox();
    var wallL = Math.round(w.left * sw);
    var wallR = Math.round(w.right * sw);
    var wallT = Math.round(w.top * sh);
    var wallB = Math.round(w.bottom * sh);
    var compLeft = wallL + Math.round(((wallR - wallL) - totalW) / 2);
    var compTop = wallT + Math.round(((wallB - wallT) - totalH) / 2);

    var els = $$(".gw-slot", stage);
    var y = compTop;
    rowMetas.forEach(function (row) {
      var x = compLeft + Math.round((totalW - row.w) / 2);
      row.items.forEach(function (it) {
        var el = els[it.i];
        if (!el) return;
        var top = y + Math.round((row.h - it.h) / 2);
        var pad = el.hasAttribute("data-noframe") ? 0 : padMould;
        el.style.left = x + "px";
        el.style.top = top + "px";
        el.style.width = it.w + "px";
        el.style.height = it.h + "px";
        el.style.padding = pad ? pad + "px" : "0";
        x += it.w + gapX;
      });
      y += row.h + gapY;
    });
    calerArts();
  }

  /* ⛔ LE LISERÉ BLANC À GAUCHE DES AFFICHES.
     `contain` centre l'oeuvre dans son emplacement. Or les dimensions de l'emplacement sont
     arrondies au pixel, et sur DEUX échelles indépendantes (X et Y) : son rapport n'est donc
     jamais exactement celui de l'oeuvre. Il reste un ou deux pixels de large à répartir, et un
     reste impair se pose entièrement d'un côté. Sur le passe-partout blanc, sans cadre, ce
     pixel se lit comme un trait tiré le long de l'affiche. Signalé le 31/07/2026 sur desktop.
     On passe en `cover` quand l'écart de rapport est sous 2 % : ce qui est rogné fait alors
     moins d'un pixel. Au-delà, `contain` reste, parce qu'il s'agirait d'une oeuvre à un autre
     format et que rogner promettrait une image que personne ne recevra. */
  function calerArts() {
    var arts = stage.querySelectorAll(".gw-slot__art");
    for (var i = 0; i < arts.length; i++) {
      var img = arts[i];
      if (!img.getAttribute("data-cale")) {
        img.setAttribute("data-cale", "1");
        img.addEventListener("load", calerArts);
      }
      if (!img.naturalWidth || !img.naturalHeight) continue;
      var boite = img.clientWidth / img.clientHeight;
      if (!boite || !isFinite(boite)) continue;
      var oeuvre = img.naturalWidth / img.naturalHeight;
      img.style.objectFit = Math.abs(boite - oeuvre) / oeuvre < 0.02 ? "cover" : "contain";
    }
  }

  function render() {
    var geo = geometry(), pl = placement(geo);

    var v = vue();
    var roomPhoto = roomBackground && roomBackground.current();
    stage.toggleAttribute('data-room-photo',!!roomPhoto);
    root.classList.toggle('gw--personal-room',!!roomPhoto);
    stage.style.aspectRatio = roomPhoto ? roomPhoto.width + ' / ' + roomPhoto.height : (v.w * PHOTO_W) + " / " + (v.h * PHOTO_H);
    /* Le fond suit la teinte choisie ; sans serie, on retombe sur l'image historique.
       ⚠️ La comparaison porte sur l'URL du fond courant, pas sur « y a-t-il deja un url » :
       c'est elle qui permet au premier rendu d'appliquer une teinte RESTAUREE. */
    var fondC = FONDS.filter(function (x) { return x.cle === state.fond; })[0] || null;
    var imgFond = roomPhoto ? roomPhoto.url : (fondC && fondC.img) || ROOM_IMG;
    if (imgFond && stage.style.backgroundImage.indexOf(imgFond) < 0) {
      stage.style.backgroundImage = 'url("' + imgFond + '")';
    }

    stage.innerHTML = geo.slots.map(function (s, i) { return slotHTML(i, s, geo, pl); }).join("");
    placeSlots();
    /* ⚠️ REPOSEE A CHAQUE RENDU : la ligne au-dessus vide la scene, une rangee posee une
       seule fois disparaissait au premier changement de disposition. */
    peindreFonds();
    renderDock();

    if (scaleNote) {
      /* Sur mobile, la légende faisait quatre lignes au-dessus des réglages : les cotes
         et la note d'échelle se lisent sur l'aperçu lui-même. On garde la seule phrase
         qui dit quoi faire. */
      scaleNote.textContent = roomPhoto ? (roomPhoto.plan ? cm(geo.w) + ' × ' + cm(geo.h) + ' · ' + t('room_hint','') : '') : useDock()
        ? t("touch_hint", "Touchez une affiche pour changer son format et son cadre")
        : "Composition " + cm(geo.w) + " × " + cm(geo.h) + " " +
          t("scale_note", "· aperçu à l’échelle de la pièce : chaque affiche est dimensionnée d’après son format.") + " " +
          t("hover_hint", "Réglez le format et le cadre de chaque affiche directement sur l’aperçu.");
    }
    renderTotal();
    syncControls();
    save();
  }
  function cm(n) { return (Math.round(n * 10) / 10).toString().replace(".", ",") + " cm"; }

  /* ---------- Récapitulatif et panier ---------- */
  function lines() {
    var geo = geometry(), out = [];
    geo.slots.forEach(function (s, i) {
      var art = state.arts[i];
      if (!art) return;
      var frame = frameOf(i);
      var v = variantFor(art, s.fmt);
      if (!v) return;
      /* Le cadre choisi doit etre facture et livre, pas seulement dessine sur
         l'apercu : on lui attache sa propre variante, a la taille de l'affiche. */
      /* La bordure voyage avec la ligne : c'est elle qui decide des proprietes envoyees au
         panier, et elle se choisit emplacement par emplacement. */
      out.push({ i: i, art: art, fmt: s.fmt, frame: frame, bord: bordOf(i),
                 v: v, fv: frameVariantFor(s.fmt, frame) });
    });
    return out;
  }
  /* ⛔⛔ LA REMISE NE PORTE QUE SUR LES AFFICHES, PAS SUR LES CADRES. Le rayon
     `toutes-les-affiches`, sur lequel les trois remises sont calees, exclut les cadres par sa
     propre regle : un cadre ne fait franchir aucun palier et n'est pas remise. Appliquer le
     pourcentage au total aurait annonce un prix que la caisse ne rendrait pas.
     ⚠️ LIGNE PAR LIGNE, ET SHOPIFY TRONQUE — IL N'ARRONDIT PAS. Mesure du 28/08 sur des paniers
     reels : 6 × 16,90 € a -15 % donne 253 centimes par ligne, pas 254, alors que la valeur
     exacte est 253,5. Meme reponse a 5 × 13,50 € (202 pour 202,5). Ce n'est donc ni un arrondi
     au plus proche ni l'arrondi du banquier — qui aurait rendu 254, puisque 254 est pair.
     ⛔ AVEC `Math.round` J'ANNONCAIS 86,16 € POUR UN PANIER QUI EN DEBITE 86,22. Six centimes,
     et c'est le mauvais sens : moins cher a l'ecran qu'a la caisse. Une remise annoncee doit
     etre au centime celle qu'on paie, sinon c'est le dernier chiffre que le client retient. */
  function remiseLot(ls) {
    var B = window.__lotBareme;
    if (!B || !B.actif || !B.paliers || !ls.length) return { pct: 0, cents: 0 };
    var atteint = null;
    for (var i = 0; i < B.paliers.length; i += 1) if (ls.length >= B.paliers[i].n) atteint = B.paliers[i];
    if (!atteint) return { pct: 0, cents: 0 };
    var cents = ls.reduce(function (a, l) { return a + Math.floor(l.v.cents * atteint.pct / 100); }, 0);
    return { pct: atteint.pct, cents: cents };
  }

  function renderTotal() {
    var ls = lines();
    var total = ls.reduce(function (a, l) { return a + l.v.cents + (l.fv ? l.fv.price : 0); }, 0);
    /* ⛔⛔ LE PRIX BARRE EST LE TARIF, PAS LE PRIX PROMO. Barrer le prix promo faisait annoncer la
       remise de lot SEULE : « 50,70 € barre, 45,63 € paye, -10 % », alors que le tarif est de
       59,70 € et l'economie reelle de 24 %. Le client lisait le plus petit des deux chiffres.
       ⚠️ UN CADRE N'A PAS DE PRIX BARRE : il entre dans les deux totaux a sa valeur, donc il ne
       gonfle pas le pourcentage. C'est la meme regle qu'a la caisse, ou il n'est pas remise. */
    var plein = ls.reduce(function (a, l) {
      return a + (l.v.plein || l.v.cents) + (l.fv ? l.fv.price : 0);
    }, 0);
    var rem = remiseLot(ls);
    var duo = Math.max(0, total - rem.cents);
    /* Le taux de la promo, DEDUIT des lignes : aucune donnee de plus a transporter, et il suit
       automatiquement une campagne qui change pendant que la page est ouverte. */
    var promo = plein > 0 ? 1 - total / plein : 0;
    var geo = geometry();
    var cnt = $("[data-gw-count]", root), tot = $("[data-gw-total]", root), add = $("#gw-add", root);
    if (cnt) cnt.textContent = ls.length + " / " + geo.slots.length;
    /* ⛔⛔ LE TOTAL AFFICHE CE QU'ON PAIE. Il annoncait 101,40 € sous un « -15 % applique au
       panier » : deux chiffres qui se contredisent sur l'ecran ou l'on decide. Le prix barre
       reste, comme partout ailleurs sur le site — c'est lui qui donne sa valeur a la remise. */
    if (tot) {
      tot.innerHTML = plein > duo
        ? '<s class="gw-recap__avant">' + esc(money(plein)) + "</s> " + esc(money(duo))
        : esc(money(duo));
    }
    if (add) {
      add.disabled = ls.length === 0;
      add.textContent = ls.length === 0
        ? t("cta_empty", "Choisissez au moins une affiche")
        : t("cta_add_n", "Ajouter __N__ affiche__S__ au panier · __PRICE__")
            .replace("__N__", String(ls.length))
            .replace("__S__", ls.length > 1 ? "s" : "")
            .replace("__PRICE__", money(duo));
    }
    /* ⛔⛔ LE PALIER DE LOT, DANS LE RECAPITULATIF (Adrien, 28/08/2026 : « pense au badge de
       reduction dans la vue »). Le but enonce est de monter le panier moyen : une remise qu'on
       n'annonce qu'a la fiche produit ne pousse personne a ajouter la sixieme affiche, parce que
       c'est ICI que le client compte les siennes.
       ⛔ ET IL DIT CE QU'IL MANQUE, PAS SEULEMENT CE QU'ON A. « -15 % acquis » est une
       recompense ; « encore 2 affiches pour -20 % » est un objectif, et c'est l'objectif qui fait
       ajouter la ligne suivante. Les deux s'affichent ensemble quand les deux existent.
       ⚠️ LE BAREME VIENT DE `window.__lotBareme`, pose par `lot-bareme.liquid` : un second
       bareme ecrit ici aurait diverge du badge de la fiche au premier ajustement.
       ⚠️ ET RIEN NE S'AFFICHE TANT QUE LES REMISES N'EXISTENT PAS : annoncer un palier sans
       remise derriere est une promesse qu'on ne tient pas. */
    var lot = $("[data-gw-lot]", root);
    var lotBadge = $("[data-gw-lot-badge]", root);

    /* ⛔⛔ LE BADGE DIT LA REMISE, D'OU QU'ELLE VIENNE (Adrien, 28/08/2026 : « le badge de la
       promo en cours doit aussi s'afficher, il n'y a aucune raison de ne pas l'afficher »).
       Il etait enferme dans la condition du BAREME DE LOT : sans palier atteint, pas de badge
       — donc deux affiches sous une promo a -15 % montraient « 39,80 € barre, 33,80 € », et
       AUCUN chiffre pour nommer l'ecart. Le panier, lui, pose « -15 % » sur la meme affiche
       seule, a deux ecrans de la : le composeur etait le seul endroit du site ou une remise
       active ne se disait pas.
       ⚠️ IL SE CALCULE SUR LES DEUX MONTANTS AFFICHES, et c'est ce qui lui permet d'etre vrai
       dans les trois cas : promo seule, lot seul, ou les deux composes. Rien a brancher le
       jour ou une troisieme remise arrive.
       ⚠️ ET IL SORT DE LA PORTE DU BAREME : celle-ci se ferme aussi quand les remises de lot
       n'existent pas (`__lotBareme` absent ou eteint), ce qui aurait garde le badge muet sous
       une promo parfaitement active. */
    var pctAffiche = plein > duo ? Math.round((1 - duo / plein) * 100) : 0;
    if (lotBadge) {
      if (ls.length && pctAffiche > 0) {
        /* ⚠️ LE REPLI SUIT LA LOCALE : « -__P__ % applique au panier » ici et « -__P__ % »
           dans les treize langues, c'est un texte long qui ressort le jour ou une cle manque,
           sur le seul ecran ou la remise doit se lire d'un coup d'oeil. */
        lotBadge.textContent = t("lot_acquis", "-__P__ %").replace("__P__", String(pctAffiche));
        lotBadge.hidden = false;
      } else {
        lotBadge.hidden = true;
        lotBadge.textContent = "";
      }
    }
    if (lot) {
      var B = window.__lotBareme;
      if (!B || !B.actif || !B.paliers || !ls.length) {
        lot.hidden = true;
        lot.textContent = "";
      } else {
        var atteint = null; var suivant = null;
        for (var i = 0; i < B.paliers.length; i += 1) {
          if (ls.length >= B.paliers[i].n) atteint = B.paliers[i];
          else if (!suivant) suivant = B.paliers[i];
        }
        var bouts = [];
        /* ⛔⛔ LE BADGE VA A DROITE DU PRIX (Adrien, 28/08/2026 : « le badge promo va a droite du
           prix, comme partout ailleurs sur le site »). Il tenait sa propre ligne, au-dessus du
           total : trois informations a rapprocher, quand la fiche, les cartes et le panier
           disent la meme chose d'un seul tenant — prix barre, prix paye, badge.
           ⚠️ IL RESTE DONC UNE LIGNE `.gw-lot`, MAIS ELLE NE PORTE PLUS QUE L'OBJECTIF
           (« encore 2 affiches pour -20 % ») : c'est lui qui fait ajouter la ligne suivante, et
           il n'a pas sa place a cote d'un montant. */
        /* ⛔⛔ LE BADGE DIT L'ECART AU TARIF, PAS LE PALIER. « -10 % » a cote d'un prix barre qui
           est le TARIF serait faux de quatorze points. Il se calcule donc sur les deux montants
           affiches, exactement comme celui du panier et celui de la fiche.
           ⚠️ ET L'OBJECTIF SUIT LA MEME ECHELLE : « encore 2 affiches pour -15 % » sous un badge
           a -24 % annoncerait une remise INFERIEURE a celle qu'on a deja. Les deux se composent
           avec la promo — 15 % puis 15 % font 27,75, pas 30. */
        var cumul = function (p) { return Math.round((1 - (1 - promo) * (1 - p / 100)) * 100); };
        if (suivant) {
          var reste = suivant.n - ls.length;
          bouts.push('<span class="gw-lot__suite">'
            + esc(t("lot_suite", "encore __N__ affiche__S__ pour -__P__ %")
              .replace("__N__", String(reste))
              .replace("__S__", reste > 1 ? "s" : "")
              .replace("__P__", String(cumul(suivant.pct))))
            + "</span>");
        }
        lot.innerHTML = bouts.join("");
        lot.hidden = bouts.length === 0;
      }
    }

    var list = $("[data-gw-list]", root);
    if (list) {
      list.innerHTML = ls.length === 0
        ? '<li class="gw-recap__none">' + esc(t("none_chosen", "Aucune affiche choisie pour l’instant.")) + "</li>"
        : ls.map(function (l) {
            /* ⛔ UNE PLAQUE N'A PAS DE CADRE, ET NE DIT DONC RIEN DU CADRE. « 30x40 · Sans
               cadre » sur une plaque aimantee repond a une question qu'on n'a pas posee — la
               rangee des cadres est cachee deux blocs plus haut — et laisse croire qu'un cadre
               etait possible et qu'on l'a refuse. */
            var frameLbl = estMetal() ? "" : frameLabel(l.frame);
            return '<li class="gw-recap__row"><img src="' + esc(thumb(l.art.img, "80x")) + '" alt="" width="26" height="36">' +
              '<span class="gw-recap__t">' + esc(l.art.title) + "</span>" +
              '<span class="gw-recap__f">' + esc(l.fmt) + (frameLbl ? " · " + esc(frameLbl) : "") + "</span>" +
              '<span class="gw-recap__p">' + money(l.v.cents + (l.fv ? l.fv.price : 0)) + "</span></li>";
          }).join("");
    }
  }

  function addAll() {
    var ls = lines();
    if (!ls.length || !window.murAddToCart) return;
    var btn = $("#gw-add", root);
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = t("adding", "Ajout en cours…");
    /* Une ligne de panier par affiche, avec le variant du cadre PROPRE à chaque
       emplacement — exactement ce que fait la fiche produit, via le même
       murAddToCart (tiroir + toast + barre de livraison compris). */
    /* ⛔ LE VISITEUR VOYAGE AVEC LA LIGNE, SINON L'ACHAT N'EST ATTRIBUABLE A RIEN. Le
       composeur posait des lignes nues : on savait qu'on avait mis au panier, jamais si la
       commande avait suivi, et la colonne « achat » du tableau serait restee vide a jamais.
       `_perso_vid` est la MEME cle que la perso et le pele-mele, lue par
       `acheteursPersoParVid` : un seul mecanisme d'attribution pour les trois outils, plutot
       qu'un troisieme a tenir d'accord. Le souligne la cache au client dans le panier. */
    var vidPanier = composeurVid();
    var props = vidPanier ? { _perso_vid: vidPanier, _source: "composeur" } : null;
    /* ⛔⛔ LA BORDURE PART AVEC L'AFFICHE, EN DEUX PROPRIETES, comme sur la fiche. `_bordure`
       porte le CODE que la presse lit : `sansMarge` ne tire a fond perdu que sur un « sans »
       EXPLICITE, donc une ligne du composeur qui n'envoie rien repart avec du blanc que
       personne n'a demande. L'autre propriete porte le texte que le client relit dans son
       panier, dans sa langue.
       ⛔ ET LES DEUX LIBELLES VIENNENT DU GABARIT, pas d'ici : les ecrire dans le script les
       sortirait des locales et les ferait deriver des treize traductions.
       ⚠️ SUR L'AFFICHE SEULEMENT, JAMAIS SUR LE CADRE : un cadre n'a pas de bordure, et la
       propriete y afficherait une option dans le panier sur une ligne qui ne la porte pas. */
    /* ⛔⛔ LA BORDURE PART LIGNE PAR LIGNE, parce qu'elle se choisit affiche par affiche. Quatre
       proprietes, exactement celles de la fiche : `_bordure` (le CODE que la presse lit —
       `sansMarge` ne tire a fond perdu que sur un « sans » EXPLICITE), `_bordure_fond` (le slug
       de la teinte, lu par `bordure-ligne.js`), et deux libelles traduits que la cliente relit
       sur sa commande.
       ⚠️ LES LIBELLES VIENNENT DU GABARIT, jamais du script : les ecrire ici les sortirait des
       locales et les ferait deriver des treize traductions.
       ⚠️ SUR L'AFFICHE SEULEMENT, JAMAIS SUR LE CADRE : un cadre n'a pas de bordure. */
    var libs = $("[data-gw-bordure-libelles]", root);
    function propsDeLigne(l) {
      var bd = l.bord;
      if (estMetal() || !libs || bd === null || bd === undefined) return props;
      var o = {};
      if (props) Object.keys(props).forEach(function (k) { o[k] = props[k]; });
      var teinte = teinteBordPar(bd);
      o._bordure = "avec";
      o[libs.getAttribute("data-titre") || "Bordure"] = libs.getAttribute("data-avec") || "Avec bordure";
      if (bd) {
        o._bordure_fond = bd;
        o[libs.getAttribute("data-couleur") || "Couleur"] = teinte ? teinte.nom : bd;
      }
      return o;
    }
    var items = [];
    ls.forEach(function (l) {
      var pa = propsDeLigne(l);
      items.push(pa ? { id: l.v.id, quantity: 1, properties: pa }
                    : { id: l.v.id, quantity: 1 });
      if (l.fv) items.push(props ? { id: l.fv.id, quantity: 1, properties: props }
                                 : { id: l.fv.id, quantity: 1 });
    });
    /* ⛔ LE DETAIL PORTE LE MONTANT, sinon la colonne Panier du Studio ne peut afficher
       qu'une coche (Adrien, 07/08/2026 : « remplacer par la valeur des paniers »). Meme
       calcul que renderTotal : la somme des variantes posees, cadres compris, en euros.
       JSON plutot qu'une phrase : le serveur le lit sans deviner un format. */
    var totalCents = ls.reduce(function (a, l) { return a + l.v.cents + (l.fv ? l.fv.price : 0); }, 0);
    if (window.__composeurLog) window.__composeurLog("panier",
      JSON.stringify({ affiches: ls.length, montant: Math.round(totalCents) / 100 }));
    window.murAddToCart({ items: items })
      .then(function () { btn.disabled = false; renderTotal(); })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  /* ---------- Sélecteur d'affiches ---------- */
  var picker = $("#gw-picker", root);
  var pickerGrid = $("[data-gw-grid]", picker);
  var pickerTabs = $("[data-gw-tabs]", picker);
  var pickerSearch = $("#gw-search", picker);
  var RECENT = "__recent__";
  var activeSlot = null, activeColl = RECENT, lastFocus = null;
  var pickerSource = []; /* liste courante AVANT filtre recherche */

  /* Tri explicite du plus récent au plus ancien. MurRecent.push empile déjà en tête,
     mais l'ordre du stockage n'est pas un contrat : une entrée écrite autrement et la
     liste se retrouvait mélangée sans que rien ne le signale. */
  function readRecent() {
    var a = (window.MurRecent && window.MurRecent.read) ? window.MurRecent.read() : [];
    return a.slice().sort(function (x, y) { return (y.ts || 0) - (x.ts || 0); });
  }
  function pushRecent(art) {
    if (window.MurRecent && window.MurRecent.push && art) window.MurRecent.push(art);
  }
  function syncTabPressed(handle) {
    $$("[data-coll]", pickerTabs).forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-coll") === handle ? "true" : "false");
    });
  }

  function openPicker(i) {
    /* ⛔ LE SEUL GESTE MESURABLE ENTRE L'ARRIVEE ET LA POSE. Adrien voulait une colonne
       « clic sur une affiche » distincte de « affiche ajoutee » ; dans le composeur, cliquer
       une carte du selecteur LA POSE, c'est le meme geste et les deux colonnes auraient donne
       le meme chiffre. Ouvrir le selecteur, en revanche, dit « je cherche une affiche » sans
       dire « j'en ai choisi une » : c'est la marche du parcours qui manquait.
       `__composeurLog` n'envoie qu'une fois par visite ce qui n'est pas « ajout » : la colonne
       compte donc des VISITEURS, pas des ouvertures repetees. */
    if (window.__composeurLog) window.__composeurLog("selecteur");
    activeSlot = i;
    lastFocus = document.activeElement;
    picker.hidden = false;
    document.body.style.overflow = "hidden";
    var geo = geometry();
    var titleEl = $("[data-gw-picker-title]", picker);
    /* Sans le format : le titre annonçait « · 30X40 » alors que le format se change juste
       après, sur l'affiche. Il figeait une donnée qui n'est pas encore décidée.

       Sur mobile, libellé court : « Affiche pour l'emplacement 2 » mange une ligne entière
       de la largeur utile pour dire ce que la grille d'affiches montre déjà. */
    if (titleEl) {
      var cle = useDock() ? "picker_slot_court" : "picker_slot";
      var repli = useDock() ? "Emplacement __N__" : "Affiche pour l’emplacement __N__";
      titleEl.textContent = t(cle, repli)
        .replace("__N__", String(i + 1)).replace("__FMT__", "").trim();
    }
    /* Chaque ouverture : recherche vide + récents (sinon 1re collection). */
    if (pickerSearch) pickerSearch.value = "";
    rechercheEnCours = "";
    ongletAvantRecherche = null;
    openDefaultPicker();
    var c = $("#gw-picker-close", picker);
    if (c) c.focus();
  }
  function closePicker() {
    picker.hidden = true;
    document.body.style.overflow = "";
    /* La feuille de filtres est en `position:fixed` : sans ça elle resterait à l'écran
       une fois le sélecteur fermé, posée sur la page. */
    basculerFeuille(false);
    if (lastFocus) lastFocus.focus();
  }

  /* Le sélecteur s'ouvre TOUJOURS sur « Récents ». C'est là qu'est, neuf fois sur dix, ce
     que le client cherche : une affiche qu'il vient de regarder sur le site.

     ⚠️ Deux replis vers la première collection existaient, ici et dans showRecent(). Ils
     partaient d'une bonne intention — ne pas ouvrir sur un onglet vide — et produisaient
     l'inverse : on atterrissait sur « Tendances » sans l'avoir demandé, et cliquer sur
     « Récents » semblait sans effet. Un onglet vide qui explique pourquoi vaut mieux
     qu'un onglet qui refuse de s'ouvrir. */
  function openDefaultPicker() {
    showRecent();
  }

  /* Le sélecteur s'ouvre sur les affiches déjà vues : c'est là que se trouve ce que le
     client cherche neuf fois sur dix.

     ⚠️ On ne bascule PAS ailleurs quand la liste est vide. J'avais fait ce repli vers la
     première collection : l'onglet Récents devenait alors impossible à sélectionner —
     on cliquait dessus et on atterrissait sur Tendances, sans rien comprendre. Un onglet
     vide qui dit pourquoi vaut mieux qu'un onglet qui refuse de s'ouvrir. */
  function showRecent() {
    quitterRecherche();
    activeColl = RECENT;
    syncTabPressed(RECENT);
    setPickerSource(readRecent());
  }

  /* Choisir un onglet, c'est sortir de la recherche : laisser le terme dans le champ
     ferait croire qu'il s'applique encore à ce qu'on regarde. */
  function quitterRecherche() {
    rechercheEnCours = "";
    ongletAvantRecherche = null;
    if (pickerSearch && pickerSearch.value) pickerSearch.value = "";
  }

  /* Rendu des facettes. Les valeurs à 0 sans être actives sont écartées côté Liquid :
     proposer un filtre qui ne renvoie rien est une impasse. */
  var pickerFiltres = $("[data-gw-filtres]", picker);
  /* ⚠️ On REPREND la barre de filtres des pages collection — mêmes balises, mêmes classes,
     donc mêmes styles et mêmes gestes. Un client qui a filtré une collection sait déjà s'en
     servir ici. J'avais d'abord inventé une grille de pastilles : cinquante valeurs à plat
     qui remplissaient la fenêtre, sans rapport avec ce que la boutique fait à deux clics de
     là. Une interface qui existe déjà n'a pas à être réinventée dans un coin. */
  function peindreFiltres() {
    if (!pickerFiltres) return;
    if (activeColl === RECENT || !filtresDispo.length) {
      pickerFiltres.hidden = true;
      pickerFiltres.innerHTML = "";
      return;
    }
    pickerFiltres.hidden = false;
    var actifs = 0;
    Object.keys(filtresActifs).forEach(function (p) { actifs += (filtresActifs[p] || []).length; });

    var groupes = filtresDispo.map(function (f) {
      /* Le paramètre est porté par la VALEUR, pas par le groupe : la pastille
         « Noir & blanc » vit dans Couleur mais interroge `custom.style`, comme sur la page
         collection. */
      function param(v) { return v.param || f.param; }
      function coche(v) { return (filtresActifs[param(v)] || []).indexOf(v.value) > -1; }
      var n = (f.values || []).filter(coche).length;
      var corps;
      if (f.couleur) {
        /* Couleur : des pastilles, comme sur la page collection. Une liste de mots —
           « Or », « Argent », « Or rose » — demande de se représenter la teinte ; la
           pastille la montre. La couleur vient du serveur (snippet filtre-swatch). */
        corps = '<div class="filters__swatches" role="list" aria-label="' + esc(f.label) + '">' +
          (f.values || []).map(function (v) {
            var on = coche(v);
            return '<label class="filters__swatch' + (on ? " is-active" : "") +
              '" title="' + esc(v.label) + " · " + v.n + '" role="listitem">' +
              '<input type="checkbox" data-f="' + esc(param(v)) + '" value="' + esc(v.value) +
              '" aria-label="' + esc(v.label) + " (" + v.n + ')"' + (on ? " checked" : "") + ">" +
              '<span class="filters__swatch-chip" style="--swatch:' + esc(v.swatch || "#d8d0bf") + '"></span>' +
              '<span class="visually-hidden">' + esc(v.label) + " (" + v.n + ")</span></label>";
          }).join("") + "</div>";
      } else {
        corps = '<div class="filters__opts">' +
          (f.values || []).map(function (v) {
            var on = coche(v);
            return '<label class="filters__opt sans">' +
              '<input type="checkbox" data-f="' + esc(param(v)) + '" value="' + esc(v.value) + '"' +
              (on ? " checked" : "") + ">" +
              "<span>" + esc(v.label) + "</span>" +
              '<span class="filters__n">' + v.n + "</span></label>";
          }).join("") + "</div>";
      }
      if (!(f.values || []).length) return "";
      /* Aucun groupe n'est ouvert d'entrée, comme sur la page collection : les panneaux
         sont posés en absolu, deux ouverts se recouvriraient. Le compte entre parenthèses
         suffit à dire qu'un filtre est actif sans avoir à déplier. */
      return '<details class="filters__group">' +
        "<summary>" +
          '<span class="filters__group-label">' + esc(f.label) +
            (n ? " <em>(" + n + ")</em>" : "") + "</span>" +
          '<span class="filters__caret" aria-hidden="true"></span>' +
        "</summary>" +
        '<div class="filters__body">' + corps + "</div>" +
      "</details>";
    }).join("");

    /* ⚠️ La structure complète de la barre, pas seulement la rangée de groupes.
       Sur desktop, `.filters__open`, le voile, l'en-tête et le pied sont en `display:none`
       et `.filters__panel` est en `display:contents` : ils ne coûtent rien. Sous 900 px la
       feuille bascule, et ce sont EUX qui font le bouton « Filtrer » et le panneau qui
       remonte du bas. Sans eux, la même feuille met les groupes en colonne — c'était le
       bug : quatre lignes empilées dans le sélecteur là où la boutique montre un bouton.
       Un seul filtre en moins par rapport aux collections, le tri, sans objet ici : la
       grille est déjà classée ventes puis vues. */
    var eff = esc(t("f_effacer", "Tout effacer"));
    pickerFiltres.innerHTML =
      '<div class="filters filters--bar" data-f-bar>' +
        '<div class="filters__form">' +
          '<button type="button" class="filters__open sans" data-f-open aria-expanded="false">' +
            '<span class="filters__open-ico" aria-hidden="true"></span>' +
            "<span>" + esc(t("f_titre", "Filtrer")) + "</span>" +
            (actifs ? '<span class="filters__badge">' + actifs + "</span>" : "") +
          "</button>" +
          '<div class="filters__backdrop" data-f-close hidden></div>' +
          '<div class="filters__panel">' +
            '<div class="filters__panel-head">' +
              '<span class="filters__panel-title sans">' + esc(t("f_titre", "Filtrer")) + "</span>" +
              (actifs ? '<button type="button" class="filters__clear filters__clear--head sans" data-f-clear>' + eff + "</button>" : "") +
              '<button type="button" class="filters__panel-x" data-f-close aria-label="' +
                esc(t("f_fermer", "Fermer")) + '"><span aria-hidden="true">×</span></button>' +
            "</div>" +
            '<div class="filters__row">' + groupes + "</div>" +
            '<div class="filters__panel-foot">' +
              (actifs ? '<button type="button" class="filters__clear sans" data-f-clear>' + eff + "</button>" : "") +
              '<button type="button" class="filters__done sans" data-f-close>' +
                esc(t("f_voir", "Voir les affiches")) + "</button>" +
            "</div>" +
          "</div>" +
          /* Sur desktop le « Tout effacer » vit dans la barre ; sous 900 px il passe dans
             l'en-tête et le pied du panneau, et celui-ci est masqué (.filters__clear--bar). */
          (actifs ? '<button type="button" class="filters__clear filters__clear--bar sans" data-f-clear>' +
            eff + " (" + actifs + ")</button>" : "") +
        "</div>" +
      "</div>";

    /* Un seul panneau ouvert à la fois, comme sur la page collection (global.js). Ce
       comportement y est branché une fois au chargement, sur un markup qui ne bouge plus ;
       ici la barre est reconstruite à chaque filtrage, donc on rebranche. */
    var grs = [].slice.call(pickerFiltres.querySelectorAll("details.filters__group"));
    grs.forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        grs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    if (feuilleOuverte) basculerFeuille(true);
  }

  /* La feuille mobile. `is-open` sur la barre suffit à la faire monter : toute l'animation
     est dans base.css, comme sur la page collection. On garde l'état à part parce que la
     barre est reconstruite à chaque filtrage — sans ça, cocher une valeur refermerait la
     feuille sous le doigt. */
  var feuilleOuverte = false;
  function basculerFeuille(ouvrir) {
    feuilleOuverte = !!ouvrir;
    var bar = pickerFiltres && pickerFiltres.querySelector("[data-f-bar]");
    if (!bar) return;
    bar.classList.toggle("is-open", feuilleOuverte);
    var b = bar.querySelector("[data-f-open]");
    if (b) b.setAttribute("aria-expanded", feuilleOuverte ? "true" : "false");
    var voile = bar.querySelector(".filters__backdrop");
    if (voile) voile.hidden = !feuilleOuverte;
  }

  /* Clic à côté : on referme les menus déroulants. Sans ça le panneau reste posé sur la
     grille et masque les affiches qu'on vient justement de filtrer. Sur mobile les groupes
     sont dépliés DANS la feuille : les refermer au moindre clic la viderait. */
  document.addEventListener("click", function (e) {
    if (!pickerFiltres || feuilleOuverte || pickerFiltres.contains(e.target)) return;
    [].forEach.call(pickerFiltres.querySelectorAll("details.filters__group[open]"),
      function (o) { o.open = false; });
  });

  var collPrecedente = null;
  function showCollection(handle) {
    if (handle === RECENT) { showRecent(); return; }
    quitterRecherche();
    /* Changer de collection efface les facettes : « Bleu » dans Voyage n'a rien à voir
       avec « Bleu » dans Animaux, et garder un filtre invisible d'un onglet à l'autre
       donne une liste vide sans explication. */
    if (collPrecedente !== null && collPrecedente !== handle) { filtresActifs = {}; }
    collPrecedente = handle;
    activeColl = handle;
    syncTabPressed(handle);
    pickerGrid.setAttribute("aria-busy", "true");
    pickerGrid.innerHTML = '<li class="gw-pick__msg">' + esc(t("loading", "Chargement des affiches…")) + "</li>";
    pickerSource = [];
    pickerGrid._list = null;
    loadCollection(handle).then(function (ps) {
      if (activeColl !== handle) return;
      pickerGrid.setAttribute("aria-busy", "false");
      setPickerSource(ps);
    }).catch(function () {
      if (activeColl !== handle) return;
      pickerGrid.setAttribute("aria-busy", "false");
      pickerSource = [];
      pickerGrid._list = null;
      pickerGrid.innerHTML = '<li class="gw-pick__msg">' + esc(t("load_fail", "Chargement impossible pour l’instant.")) +
        ' <button type="button" data-retry>' + esc(t("retry", "Réessayer")) + "</button></li>";
    });
  }

  function setPickerSource(ps) {
    pickerSource = Array.isArray(ps) ? ps : [];
    /* Les récents gardent leur ordre : c'est une chronologie, pas un classement. */
    if (activeColl !== RECENT) pickerSource = trierParPopularite(pickerSource);
    peindreFiltres();
    paintProducts();
  }

  /* Terme cherché sur toute la boutique, "" quand on est sur un onglet. */
  var rechercheEnCours = "";
  /* L'onglet d'où l'on vient : vider le champ doit y ramener, pas retomber ailleurs. */
  var ongletAvantRecherche = null;

  function lancerRecherche(q) {
    rechercheEnCours = q;
    activeColl = null;
    syncTabPressed(null);
    /* Une recherche traverse les collections : les facettes de l'onglet quitté n'ont plus
       de sens, et Shopify n'expose pas de facettes sur la recherche. */
    filtresActifs = {};
    filtresDispo = [];
    collPrecedente = null;
    peindreFiltres();
    pickerGrid.setAttribute("aria-busy", "true");
    pickerGrid.innerHTML = '<li class="gw-pick__msg">' + esc(t("loading", "Chargement des affiches…")) + "</li>";
    loadRecherche(q).then(function (ps) {
      if (rechercheEnCours !== q) return;
      pickerGrid.setAttribute("aria-busy", "false");
      setPickerSource(ps);
    }).catch(function () {
      if (rechercheEnCours !== q) return;
      pickerGrid.setAttribute("aria-busy", "false");
      pickerSource = [];
      pickerGrid._list = null;
      pickerGrid.innerHTML = '<li class="gw-pick__msg">' + esc(t("load_fail", "Chargement impossible pour l’instant.")) +
        ' <button type="button" data-retry>' + esc(t("retry", "Réessayer")) + "</button></li>";
    });
  }

  function paintProducts() {
    var ps = pickerSource || [];
    var q = rechercheEnCours;
    /* Plus de filtre en JavaScript : la liste vient déjà de la recherche de la boutique. */
    var list = ps.slice();
    var geo = geometry();
    var fmt = activeSlot != null ? geo.slots[activeSlot].fmt : roleFmt().m;
    if (!list.length) {
      pickerGrid._list = null;
      var msg;
      if (q) {
        msg = t("no_results", "Aucune affiche ne correspond à « __Q__ ».").replace("__Q__", q);
      } else if (activeColl === RECENT) {
        msg = t("empty_recent", "Aucune affiche récente pour l’instant. Choisissez une collection ci-dessus.");
      } else {
        msg = t("empty_collection", "Aucune affiche dans cette collection pour l’instant.");
      }
      pickerGrid.innerHTML = '<li class="gw-pick__msg">' + esc(msg) + "</li>";
      return;
    }
    pickerGrid.innerHTML = list.map(function (p, n) {
      var v = p.variants && p.variants[fmt];
      return '<li><button type="button" class="gw-pick" data-pick="' + n + '">' +
        '<span class="gw-pick__art"><img src="' + esc(thumb(p.img, "300x")) + '" alt="" loading="lazy"></span>' +
        '<span class="gw-pick__t">' + esc(p.title) + "</span>" +
        '<span class="gw-pick__p">' + (v ? money(v.cents) : "") + "</span></button></li>";
    }).join("");
    pickerGrid._list = list;
  }

  pickerGrid.addEventListener("click", function (e) {
    if (e.target.closest("[data-retry]")) {
      if (activeColl === RECENT) showRecent();
      else showCollection(activeColl);
      return;
    }
    var b = e.target.closest("[data-pick]");
    if (!b || !pickerGrid._list) return;
    /* Nouvelle affiche : elle hérite du cadre par défaut (étape 3) tant que
       l'utilisateur ne la personnalise pas — on ne fixe donc PAS slotFrames ici. */
    var art = pickerGrid._list[parseInt(b.getAttribute("data-pick"), 10)];
    state.arts[activeSlot] = art;
    /* Une affiche posee sur le mur : c'est l'acte qui dit que le composeur SERT. */
    if (window.__composeurLog) window.__composeurLog("ajout", (art && art.handle) || "");
    state.choisis[activeSlot] = true;
    pushRecent(art);
    selectedSlot = activeSlot;
    closePicker();
    render();
  });
  if (pickerFiltres) {
    pickerFiltres.addEventListener("click", function (e) {
      if (e.target.closest("[data-f-open]")) { basculerFeuille(true); return; }
      if (e.target.closest("[data-f-close]")) { basculerFeuille(false); return; }
      if (!e.target.closest("[data-f-clear]")) return;
      filtresActifs = {};
      showCollection(activeColl);
    });
    /* `change`, pas `click` : ce sont de vraies cases à cocher, comme sur la page
       collection. Elles répondent donc aussi à la barre d'espace et aux lecteurs d'écran,
       qui ne produisent pas toujours de clic. */
    pickerFiltres.addEventListener("change", function (e) {
      var c = e.target.closest("input[data-f]");
      if (!c) return;
      var p = c.getAttribute("data-f");
      var v = c.value;
      var liste = filtresActifs[p] || [];
      var i = liste.indexOf(v);
      if (c.checked) { if (i < 0) liste.push(v); }
      else if (i > -1) liste.splice(i, 1);
      if (liste.length) filtresActifs[p] = liste; else delete filtresActifs[p];
      showCollection(activeColl);
    });
  }

  pickerTabs.addEventListener("click", function (e) {
    var b = e.target.closest("[data-coll]");
    if (!b) return;
    var h = b.getAttribute("data-coll");
    if (h === RECENT) showRecent();
    else showCollection(h);
  });
  if (pickerSearch) {
    var st;
    pickerSearch.addEventListener("input", function () {
      clearTimeout(st);
      /* 300 ms : chaque frappe part maintenant vers la boutique, plus vers un tableau
         déjà en mémoire. Assez court pour suivre la saisie, assez long pour ne pas
         envoyer une requête par lettre. */
      st = setTimeout(function () {
        var q = String(pickerSearch.value || "").trim();
        if (q === rechercheEnCours) return;
        if (!q) {
          /* Champ vidé : on revient à l'onglet où l'on était. */
          rechercheEnCours = "";
          if (ongletAvantRecherche === RECENT) showRecent();
          else showCollection(ongletAvantRecherche || RECENT);
          return;
        }
        if (!rechercheEnCours) ongletAvantRecherche = activeColl;
        lancerRecherche(q);
      }, 300);
    });
  }
  $("#gw-picker-close", picker).addEventListener("click", closePicker);
  picker.addEventListener("click", function (e) {
    if (e.target === picker || e.target.closest("[data-gw-backdrop]")) closePicker();
  });
  document.addEventListener("keydown", function (e) {
    /* Échap referme d'abord la feuille de filtres, pas le sélecteur : fermer les deux
       d'un coup ferait perdre la sélection en cours pour avoir voulu replier un panneau. */
    if (e.key === "Escape" && !picker.hidden) {
      if (feuilleOuverte) basculerFeuille(false); else closePicker();
    }
  });

  /* ---------- Contrôles ----------
     Composition, taille et cadre sont construits ICI, à partir des constantes
     ci-dessus, et non recopiés dans le Liquid : une seule source de vérité, donc
     pas de miniature qui finit par mentir sur la composition qu'elle annonce. */
  function buildControls() {
    var lb = $("[data-gw-layouts]", root);
    lb.innerHTML = LAYOUTS.map(function (L) {
      var n = L.rows.reduce(function (a, r) { return a + r.length; }, 0);
      /* La miniature réutilise les rôles : elle suit donc toute modification
         d'une composition sans être redessinée à la main. */
      var mini = L.rows.map(function (r) {
        return '<span class="gw-layout__row">' + r.map(function (role) {
          var d = { s: [7, 10], m: [9, 13], l: [12, 17] }[role];
          return '<span class="gw-layout__cell" style="width:' + d[0] + 'px;height:' + d[1] + 'px"></span>';
        }).join("") + "</span>";
      }).join("");
      return '<button type="button" class="gw-layout" data-layout="' + L.id + '" aria-pressed="false">' +
        '<span class="gw-layout__mini" aria-hidden="true">' + mini + "</span>" +
        '<span class="gw-layout__n">' + esc(L.name) + " · " + n + "</span></button>";
    }).join("");

    /* Déroulant sur desktop, rail visible sur mobile. Dans la colonne étroite du panneau,
       huit pastilles prenaient trois lignes au milieu du parcours ; sur un téléphone le
       rail ne coûte qu'une ligne et un déroulant de plus ajouterait un geste. */
    var pw = $("[data-gw-presets-wrap]", root);
    if (pw) {
      var sync = function () {
        if (MQ_RAIL.matches) pw.setAttribute("open", "");
        else pw.removeAttribute("open");
      };
      sync();
      if (MQ_RAIL.addEventListener) MQ_RAIL.addEventListener("change", sync);
      else if (MQ_RAIL.addListener) MQ_RAIL.addListener(sync);
    }
    var pb = $("[data-gw-presets]", root);
    if (pb) {
      pb.innerHTML = MURS.map(function (M) {
        return '<button type="button" class="gw-preset" data-preset="' + M.id + '" aria-pressed="false">' +
          esc(M.name) + ' · ' + M.handles.length + '</button>';
      }).join("");
    }

    /* ⛔⛔ NI CADRE NI BORDURE SUR UNE PLAQUE (Adrien, 28/08/2026 : « attention pas de bordure
       pour les affiches metallisees »). Une plaque aimantee se pose telle quelle : pas de
       moulure a sa cote, et aucune marge blanche a l'impression. Laisser les deux rangees
       visibles proposerait deux options qu'aucune commande ne pourrait honorer — et la premiere,
       le cadre, n'a meme pas de variante a ces cotes, donc le client aurait clique dans le vide.
       ⚠️ ON FORCE AUSSI L'ETAT, pas seulement l'affichage : un mur repris du stockage local peut
       porter « avec » et un cadre choisis en papier, et ils repartiraient au panier sans que rien
       ne les montre a l'ecran. Cacher une option sans la neutraliser, c'est la garder active. */
    var etapeCadre = $("[data-gw-etape-cadre]", root);
    var blocCadres = $("[data-gw-cadres]", root);

    if (estMetal()) {
      state.frame = NO_FRAME;
      state.slotFrames = {};
      state.slotBord = {};
      if (etapeCadre) etapeCadre.hidden = true;
      if (blocCadres) blocCadres.hidden = true;
      /* ⚠️ LA BORDURE N'A PLUS DE RANGEE GLOBALE A CACHER : elle vit sur chaque emplacement,
         et `slotHTML` ne la dessine pas en metal. Vider `slotBord` suffit — et il le FAUT : un
         mur repris du stockage local peut porter des bordures choisies en papier. */
    }

    var fb = $("[data-gw-frames]", root);
    fb.innerHTML = FRAMES.map(function (f) {
      var sw = f === NO_FRAME
        ? '<span class="gw-frame__sw gw-frame__sw--none"></span>'
        : '<span class="gw-frame__sw" style="background:' + FRAME_SWATCH[f] + '"></span>';
      return '<button type="button" class="gw-frame" data-frame="' + esc(f) + '" aria-pressed="false">' +
        sw + esc(frameLabel(f)) + "</button>";
    }).join("");

    var tb = $("[data-gw-tabs]", picker);
    var recentTab = '<button type="button" class="gw-pick__tab" data-coll="' + RECENT + '" aria-pressed="false">' +
      esc(t("recent", "Récents")) + "</button>";
    tb.innerHTML = recentTab + COLLECTIONS.map(function (c) {
      return '<button type="button" class="gw-pick__tab" data-coll="' + esc(c.handle) + '" aria-pressed="false">' +
        esc(c.title) + "</button>";
    }).join("");
  }

  /* Format / cadre : sur le mur (desktop) ou dans le dock (mobile). */
  function applySlotFmt(zi, zf, focusRoot) {
    state.slotFmt[zi] = zf;
    /* Choisir un format sur une affiche posée automatiquement, c'est l'adopter. */
    state.choisis[zi] = true;
    selectedSlot = zi;
    render();
    var scope = focusRoot || stage;
    var zb = scope.querySelector('[data-slot-fmt="' + zi + '"][data-fmt="' + zf + '"]');
    if (zb) zb.focus();
  }
  /* ⚠️ `data-bord-non` PLUTOT QU'UNE VALEUR SENTINELLE. « Pas de bordure » et « bordure papier »
     ont tous deux un `data-bord` vide : sans ce second attribut, les deux pastilles seraient
     indistinguables et la premiere aurait pose une bordure blanche que personne n'a demandee. */
  function applySlotBord(si, val, focusRoot, non) {
    state.slotBord[si] = non ? undefined : val;
    if (non) delete state.slotBord[si];
    state.choisis[si] = true;
    selectedSlot = si;
    render();
    var scope = focusRoot || stage;
    var sel = '[data-slot-bord="' + si + '"]' + (non ? "[data-bord-non]" : '[data-bord="' + String(val).replace(/"/g, '\\"') + '"]');
    var nb = scope.querySelector(sel);
    if (nb) nb.focus();
  }

  function applySlotFrame(si, f, focusRoot) {
    state.slotFrames[si] = f;
    state.choisis[si] = true;
    selectedSlot = si;
    render();
    var scope = focusRoot || stage;
    var nb = scope.querySelector('[data-slot-frame="' + si + '"][data-frame="' + f.replace(/"/g, '\\"') + '"]');
    if (nb) nb.focus();
  }

  stage.addEventListener("click", function (e) {
    var sz = e.target.closest("[data-slot-fmt]");
    if (sz) {
      if (sz.disabled) return;
      applySlotFmt(parseInt(sz.getAttribute("data-slot-fmt"), 10), sz.getAttribute("data-fmt"), stage);
      return;
    }
    var sw = e.target.closest("[data-slot-frame]");
    if (sw) {
      if (sw.disabled) return;
      applySlotFrame(parseInt(sw.getAttribute("data-slot-frame"), 10), sw.getAttribute("data-frame"), stage);
      return;
    }
    var bo = e.target.closest("[data-slot-bord]");
    if (bo) {
      applySlotBord(parseInt(bo.getAttribute("data-slot-bord"), 10),
        bo.getAttribute("data-bord"), stage, bo.hasAttribute("data-bord-non"));
      return;
    }
    var s = e.target.closest("[data-slot]");
    /* Toucher le mur À CÔTÉ d'une affiche la désélectionne.
       Au tactile, choisir un emplacement pose « Changer l'affiche » par-dessus l'affiche et
       ouvre ses réglages sous l'aperçu ; sans geste pour annuler, le cartouche restait collé
       jusqu'au prochain appui sur une AUTRE affiche.
       ⚠️ L'écouteur est sur l'aperçu, pas sur le document. Posé sur le document, il annulait
       la sélection au moindre appui ailleurs — y compris sur les réglages qu'on venait
       d'ouvrir, ce qui rendait le socle inutilisable. Le geste que le client fait, c'est
       « je touche le mur, pas une affiche » : il n'a de sens que dans l'image. */
    if (!s) {
      if (useDock() && selectedSlot != null) { selectedSlot = null; render(); }
      return;
    }
    var idx = parseInt(s.getAttribute("data-slot"), 10);
    if (useDock()) {
      /* Deux appuis, deux intentions. Le premier montre les réglages sous l'aperçu — c'est
         ce qu'on veut faire le plus souvent, changer un format ou un cadre. Le second, sur
         la MÊME affiche, ouvre le sélecteur : le libellé « Changer l'affiche » apparaît
         alors sur l'emplacement choisi, sinon rien n'annoncerait ce deuxième geste.
         Un emplacement vide n'a pas d'affiche à régler : il ouvre directement. */
      var dejaChoisi = selectedSlot === idx;
      selectSlot(idx);
      if (!state.arts[idx] || dejaChoisi) openPicker(idx);
      return;
    }
    openPicker(idx);
  });

  if (dock) {
    dock.addEventListener("click", function (e) {
      var sz = e.target.closest("[data-slot-fmt]");
      if (sz) {
        if (sz.disabled) return;
        applySlotFmt(parseInt(sz.getAttribute("data-slot-fmt"), 10), sz.getAttribute("data-fmt"), dock);
        return;
      }
      var sw = e.target.closest("[data-slot-frame]");
      if (sw) {
        if (sw.disabled) return;
        applySlotFrame(parseInt(sw.getAttribute("data-slot-frame"), 10), sw.getAttribute("data-frame"), dock);
        return;
      }
      var bo = e.target.closest("[data-slot-bord]");
      if (bo) {
        applySlotBord(parseInt(bo.getAttribute("data-slot-bord"), 10),
          bo.getAttribute("data-bord"), dock, bo.hasAttribute("data-bord-non"));
        return;
      }
      if (e.target.closest("[data-gw-dock-pick]") && selectedSlot != null) {
        openPicker(selectedSlot);
      }
    });
  }

  function syncControls() {
    $$("[data-layout]", root).forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-layout") === state.layout ? "true" : "false");
    });
    $$("[data-gw-frames] [data-frame]", root).forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-frame") === state.frame ? "true" : "false");
    });

    /* Le mur prêt en cours n'était marqué nulle part : on venait d'en appliquer un et
       aucune pastille ne le disait, alors que la disposition et le cadre, eux, montrent
       leur sélection. */
    $$("[data-preset]", root).forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-preset") === state.mur ? "true" : "false");
    });
  }
  /* Compléter les emplacements vides. Deux sources, dans cet ordre :
       1. la RÉSERVE du mur prêt en cours — six affiches par mur, cf. MURS ;
       2. les dernières affiches vues par le client sur le site.

     Jamais un handle déjà accroché : deux fois la même image sur un mur se voit
     immédiatement. Et jamais rien à défaut de source — si le client n'a choisi aucun mur
     et n'a rien consulté, les emplacements restent vides. On ne compose pas à sa place :
     un mur pré-rempli d'affiches qu'il n'a jamais vues n'est pas une aide, c'est une
     suggestion qu'il n'a pas demandée. */
  /* Repose les dernières affiches vues sur les emplacements QUE LE CLIENT N'A JAMAIS TOUCHÉS.
   *
   * Ce qu'elle garantit, et pourquoi chaque garantie compte :
   *   - un emplacement choisi par le client ne bouge pas, jamais, même si l'affiche qu'il y a
   *     mise est aussi dans ses récentes ;
   *   - une affiche déjà présente ailleurs sur le mur n'y est pas remise en double ;
   *   - l'ordre est celui des récentes, la plus récente sur le premier emplacement libre.
   *
   * Elle ne complète PAS avec la réserve d'un mur prêt : c'est le travail de `completer`, qui
   * répond à une autre question (« il manque des affiches, que met-on ? »). Ici la question est
   * « le client vient d'en voir de nouvelles, où les pose-t-on ? ».
   */
  function rafraichirRecents(n) {
    var recents = readRecent();
    if (!recents.length) return;

    var libres = [];
    for (var i = 0; i < n; i++) if (!state.choisis[i]) libres.push(i);
    if (!libres.length) return;

    /* Les affiches que le client a lui-même posées : on ne les redouble pas. */
    var pris = {};
    Object.keys(state.arts).forEach(function (k) {
      if (state.choisis[k] && state.arts[k]) pris[state.arts[k].handle] = 1;
    });

    var aPoser = recents.filter(function (r) {
      if (pris[r.handle]) return false;
      pris[r.handle] = 1;
      return true;
    });
    if (!aPoser.length) return;

    var change = false;
    for (var j = 0; j < libres.length; j++) {
      var slot = libres[j];
      var art = aPoser[j];
      if (!art) {
        /* Plus de récentes que d'emplacements libres : on vide ceux qui restent plutôt que
           d'y laisser une affiche d'une visite précédente, qui n'est plus dans la liste. */
        if (state.arts[slot]) { delete state.arts[slot]; change = true; }
        continue;
      }
      if (!state.arts[slot] || state.arts[slot].handle !== art.handle) {
        state.arts[slot] = art;
        change = true;
      }
    }
    if (change) render();
  }

  function completer(n, apres) {
    var vides = [];
    for (var j = 0; j < n; j++) if (!state.arts[j]) vides.push(j);
    if (!vides.length) { render(); return; }

    var pris = {};
    for (var i = 0; i < n; i++) if (state.arts[i]) pris[state.arts[i].handle] = 1;

    /* Les récents sont déjà au format d'une affiche normalisée (mêmes clés que
       normalize) : ils se posent directement, sans aller les rechercher. */
    var recents = readRecent().filter(function (r) {
      if (pris[r.handle]) return false;
      pris[r.handle] = 1;
      return true;
    });
    var M = MURS.filter(function (x) { return x.id === state.mur; })[0];
    var aCharger = M ? M.handles.filter(function (h) {
      if (pris[h]) return false;
      pris[h] = 1;
      return true;
    }) : [];

    /* La réserve du mur passe avant : elle est composée pour aller ensemble. */
    var k = 0;
    var poser = function (art) { if (art && vides[k] != null) state.arts[vides[k++]] = art; };

    render();
    if (!aCharger.length) {
      recents.slice(0, vides.length).forEach(poser);
      render();
      if (apres) apres();
      return;
    }
    Promise.all(aCharger.slice(0, vides.length).map(loadArt)).then(function (arts) {
      arts.forEach(poser);
      recents.slice(0, vides.length - k).forEach(poser);
      render();
      if (apres) apres();
    });
  }

  root.addEventListener("click", function (e) {
    var pr = e.target.closest("[data-preset]");
    if (pr) { applyPreset(pr.getAttribute("data-preset")); return; }
    var l = e.target.closest("[data-layout]");
    if (l) {
      /* Changer de composition change le NOMBRE d'emplacements : on garde les
         affiches, cadres et formats des emplacements qui existent encore. */
      state.layout = l.getAttribute("data-layout");
      var n = geometry().slots.length;
      Object.keys(state.arts).forEach(function (k) { if (+k >= n) delete state.arts[k]; });
      Object.keys(state.slotFrames).forEach(function (k) { if (+k >= n) delete state.slotFrames[k]; });
      Object.keys(state.slotFmt).forEach(function (k) { if (+k >= n) delete state.slotFmt[k]; });
      Object.keys(state.choisis).forEach(function (k) { if (+k >= n) delete state.choisis[k]; });
      if (selectedSlot != null && selectedSlot >= n) selectedSlot = n ? 0 : null;
      /* completer() rend lui-même : les affiches arrivent par le réseau, et la
         disposition doit apparaître avant elles. */
      completer(n); return;
    }
    var f = e.target.closest("[data-gw-frames] [data-frame]");
    if (f) { state.frame = f.getAttribute("data-frame"); render(); return; }

    if (e.target.closest("[data-gw-reset]")) {
      /* Vider, c'est vider : sans remettre state.mur à zéro, agrandir la composition
         juste après rappellerait le mur qu'on vient d'effacer. */
      state.arts = {}; state.slotFrames = {}; state.slotFmt = {}; state.mur = null;
      selectedSlot = null; render(); return;
    }
  });
  $("#gw-add", root).addEventListener("click", addAll);

  /* ---------- Les pastilles de mur (les memes que la fiche produit) ---------- */
  /* Le rebond d'invitation s'arrete au premier clic, comme sur la PDP : une invitation qui
     continue apres qu'on l'a acceptee devient un tic. */
  var fondsServis = false;
  function peindreFonds() {
    if (roomBackground && roomBackground.current()) return;
    if (FONDS.length < 2) return;
    var row = document.createElement("div");
    row.className = "pdp-murs" + (fondsServis ? " a-servi" : "");
    FONDS.forEach(function (m) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pdp-mur" + (m.cle === state.fond ? " is-on" : "");
      b.style.background = m.hex;
      b.dataset.mur = m.cle;
      /* Le nom ne s'affiche pas : il ne sert qu'a l'etiquette accessible, une pastille de
         couleur ne disant rien a qui ne voit pas l'ecran. */
      b.setAttribute("aria-label", m.nom || m.cle);
      b.setAttribute("aria-pressed", m.cle === state.fond ? "true" : "false");
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        poserFond(m.cle);
      });
      row.appendChild(b);
    });
    stage.appendChild(row);
  }
  /* La pastille s'allume tout de suite, le mur change quand l'image est decodee : poser un
     fichier pas encore telecharge laisse l'ancien mur a l'ecran sans que rien ne bouge, et le
     client croit que son clic n'a pas pris. Meme decoupage des deux temps que sur la PDP,
     meme repli sans decode() pour les navigateurs qui ne l'ont pas. */
  function poserFond(cle) {
    var m = FONDS.filter(function (x) { return x.cle === cle; })[0];
    if (!m) return;
    state.fond = cle;
    fondsServis = true;
    $$(".pdp-mur", stage).forEach(function (b) {
      var on = b.dataset.mur === cle;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var row = $(".pdp-murs", stage);
    if (row) row.classList.add("a-servi");
    var im = new Image();
    im.src = m.img;
    var pose = function () { if ((!roomBackground || !roomBackground.current()) && state.fond === cle) stage.style.backgroundImage = 'url("' + m.img + '")'; };
    if (im.decode) im.decode().then(pose).catch(pose);
    else { im.onload = pose; im.onerror = pose; }
    save();
  }

  /* ---------- Persistance locale ----------
     Desenio sauvegarde les compositions côté serveur (?cart=zqMbaSIQ, donc
     partageable). Ici, pas de backend : localStorage, pour que rafraîchir la
     page ne détruise pas le travail. Ce n'est pas partageable — assumé. */
  function save() {
    try {
      var a = {};
      Object.keys(state.arts).forEach(function (k) { a[k] = state.arts[k].handle; });
      var sf = {};
      Object.keys(state.slotFrames).forEach(function (k) { if (state.arts[k]) sf[k] = state.slotFrames[k]; });
      var sz = {};
      Object.keys(state.slotFmt).forEach(function (k) { sz[k] = state.slotFmt[k]; });
      var ch = {};
      Object.keys(state.choisis).forEach(function (k) { if (state.arts[k]) ch[k] = 1; });
      localStorage.setItem(STORE_KEY, JSON.stringify({ l: state.layout, m: state.mur, f: state.frame, sf: sf, sz: sz, a: a, ch: ch, bg: state.fond }));
    } catch (e) {}
  }
  function restore() {
    var d = SAUVEGARDE;
    if (!d) return Promise.resolve();
    if (LAYOUTS.some(function (l) { return l.id === d.l; })) state.layout = d.l;
    /* Le mur est restauré lui aussi : sans lui, la réserve serait perdue et agrandir la
       composition après un rafraîchissement laisserait des trous. */
    if (MURS.some(function (x) { return x.id === d.m; })) state.mur = d.m;
    if (FONDS.some(function (x) { return x.cle === d.bg; })) state.fond = d.bg;
    if (FRAMES.indexOf(d.f) > -1) state.frame = d.f;
    if (d.sf) Object.keys(d.sf).forEach(function (k) {
      if (FRAMES.indexOf(d.sf[k]) > -1) state.slotFrames[k] = d.sf[k];
    });
    if (d.sz) Object.keys(d.sz).forEach(function (k) {
      if (formatsDuSupport().indexOf(d.sz[k]) > -1) state.slotFmt[k] = d.sz[k];
    });
    /* ⚠️ Les sauvegardes d'avant le 31/07/2026 n'ont pas de `ch` : tout ce qu'elles
       contiennent a été choisi par la page, pas par le client, et on ne peut pas le
       distinguer. On les traite comme entièrement CHOISIES plutôt que comme entièrement
       libres : rafraîchir un mur que quelqu'un a peut-être composé serait le seul dégât
       irréversible de cette correction. Le mur redevient rafraîchissable dès qu'il change
       de disposition ou qu'un emplacement se libère. */
    var a = d.a || {};
    var keys = Object.keys(a);
    if (d.ch) Object.keys(d.ch).forEach(function (k) { state.choisis[k] = true; });
    else keys.forEach(function (k) { state.choisis[k] = true; });
    if (!keys.length) return Promise.resolve();
    /* On recharge chaque affiche par son handle. L'ancien code balayait les collections
       du sélecteur : une affiche posée par un mur prêt n'y figure pas forcément, elle
       n'était jamais retrouvée, et le mur revenait VIDE après un rafraîchissement.
       loadArt avale ses propres erreurs — une affiche retirée du catalogue laisse son
       emplacement vide au lieu de faire échouer la restauration entière. */
    return Promise.all(keys.map(function (k) {
      return loadArt(a[k]).then(function (art) { if (art) state.arts[k] = art; });
    }));
  }

  /* ⛔ LE SUPPORT SE LIT AVANT TOUT LE RESTE. `buildControls` peint les cadres, `render` calcule
     les centimetres, et les deux demandent au support quelles cotes existent. Le lire apres, et
     c'est un mur papier qui s'affiche une fraction de seconde avant de se refaire — ou pas du
     tout, si rien ne redemande un rendu. */
  lireSupport();
  chargerPop();
  buildControls();
  render();
  /* ⛔ LE MUR DE L'URL PASSE AVANT LA REPRISE LOCALE. Quelqu'un qui clique « Composer mon mur »
     dans un article a demande CE mur-la : lui rendre sa composition d'avant-hier ignorerait le
     geste qu'il vient de faire. C'est ce que fait deja `applyPreset`, qui remet les emplacements
     a zero : un mur propose est un point de depart, pas une surcouche.
     ⛔ ET ON NE SORT PAS DE LA FONCTION POUR AUTANT. Un `return` ici sauterait l'ecouteur de
     redimensionnement pose vingt lignes plus bas : arriver depuis un article donnerait un mur qui
     ne se redessine plus a la rotation du telephone, sans la moindre erreur. On BRANCHE. */
  var murPropose = murDepuisUrl();
  if (murPropose) MURS.push(murPropose);
  var demarrage = murPropose
    ? Promise.resolve().then(function () { applyPreset("url"); })
    : restore().then(function () {
    render();
    /* Les dernières affiches vues se posent sur les emplacements que le client n'a JAMAIS
       touchés. Il arrive sur SON mur plutôt que sur une grille vide, et ce sont des affiches
       qu'il a lui-même ouvertes, pas une suggestion tombée du ciel.
       S'il n'a rien consulté, readRecent() est vide et le mur reste vide.

       ⛔ LA CONDITION ÉTAIT `if (!Object.keys(state.arts).length)`, ET C'ÉTAIT UN PIÈGE.
       `render()` se termine par `save()` : le tout premier remplissage automatique
       s'enregistrait donc lui-même, et la condition n'était plus jamais vraie. La fonction
       ne jouait qu'UNE FOIS PAR NAVIGATEUR, à vie. Le garde-fou était censé protéger le
       travail du client ; il protégeait aussi la proposition de la machine, que personne
       n'avait choisie. On distingue maintenant les deux avec `state.choisis`. */
    rafraichirRecents(geometry().slots.length);
      });
  demarrage.catch(function () {});
  if (window.AfGalleryRoom) roomBackground = window.AfGalleryRoom.create(root,function(mode){
    if (mode === 'position') placeSlots(); else render();
  });

  var rz;
  window.addEventListener("resize", function () { clearTimeout(rz); rz = setTimeout(render, 150); });
})();

/* picker-recent-1 */
